// Auto-generated exercise name translations for all supported languages
// Keys match exercise IDs from src/lib/strengthData.ts

const exerciseNames: Record<string, Record<string, string>> = {
  ko: {
    "bench-press": "벤치 프레스",
    "squat": "스쿼트",
    "deadlift": "데드리프트",
    "shoulder-press": "숄더 프레스",
    "barbell-curl": "바벨 컬",
    "bent-over-row": "벤트 오버 로우",
    "incline-bench-press": "인클라인 벤치 프레스",
    "front-squat": "프론트 스쿼트",
    "romanian-deadlift": "루마니안 데드리프트",
    "hip-thrust": "힙 쓰러스트",
    "power-clean": "파워 클린",
    "close-grip-bench": "클로즈 그립 벤치 프레스",
    "lying-tricep-ext": "라잉 트라이셉 익스텐션",
    "barbell-shrug": "바벨 슈러그",
    "ez-bar-curl": "EZ바 컬",
    "overhead-press": "오버헤드 프레스",
    "sumo-deadlift": "스모 데드리프트",
    "pendlay-row": "펜들레이 로우",
    "barbell-lunge": "바벨 런지",
    "deficit-deadlift": "디피싯 데드리프트",
    "floor-press": "플로어 프레스",
    "zercher-squat": "저처 스쿼트",
    "snatch": "스내치",
    "clean-and-jerk": "클린 앤 저크",
    "good-morning": "굿모닝",
    "rack-pull": "랙 풀",
    "push-press": "푸시 프레스",
    "decline-bench-press": "디클라인 벤치 프레스",
    "t-bar-row": "T바 로우",
    "pause-squat": "포즈 스쿼트",
    "stiff-leg-deadlift": "스티프 레그 데드리프트",
    "behind-neck-press": "비하인드 넥 프레스",
    "preacher-curl": "프리처 컬",
    "skull-crusher": "스컬 크러셔",
    "pull-ups": "풀업",
    "push-ups": "푸시업",
    "dips": "딥스",
    "chin-ups": "친업",
    "muscle-ups": "머슬업",
    "sit-ups": "싯업",
    "pistol-squat": "피스톨 스쿼트",
    "handstand-push-up": "핸드스탠드 푸시업",
    "planche": "플란체",
    "front-lever": "프론트 레버",
    "hanging-leg-raise": "행잉 레그 레이즈",
    "burpees": "버피",
    "inverted-row": "인버티드 로우",
    "dragon-flag": "드래곤 플래그",
    "l-sit": "L-싯",
    "back-lever": "백 레버",
    "nordic-curl": "노르딕 컬",
    "dumbbell-bench-press": "덤벨 벤치 프레스",
    "dumbbell-curl": "덤벨 컬",
    "incline-db-bench": "인클라인 덤벨 벤치 프레스",
    "dumbbell-shoulder-press": "덤벨 숄더 프레스",
    "dumbbell-lateral-raise": "덤벨 레터럴 레이즈",
    "dumbbell-row": "덤벨 로우",
    "hammer-curl": "해머 컬",
    "goblet-squat": "고블릿 스쿼트",
    "dumbbell-fly": "덤벨 플라이",
    "dumbbell-pullover": "덤벨 풀오버",
    "dumbbell-lunge": "덤벨 런지",
    "dumbbell-shrug": "덤벨 슈러그",
    "concentration-curl": "컨센트레이션 컬",
    "dumbbell-tricep-ext": "덤벨 트라이셉 익스텐션",
    "dumbbell-reverse-fly": "덤벨 리버스 플라이",
    "arnold-press": "아놀드 프레스",
    "dumbbell-front-raise": "덤벨 프론트 레이즈",
    "dumbbell-romanian-dl": "덤벨 루마니안 데드리프트",
    "dumbbell-step-up": "덤벨 스텝업",
    "dumbbell-skull-crusher": "덤벨 스컬 크러셔",
    "incline-dumbbell-curl": "인클라인 덤벨 컬",
    "dumbbell-calf-raise": "덤벨 카프 레이즈",
    "sled-leg-press": "슬레드 레그 프레스",
    "leg-extension": "레그 익스텐션",
    "chest-press": "체스트 프레스",
    "hack-squat": "핵 스쿼트",
    "seated-leg-curl": "시티드 레그 컬",
    "machine-calf-raise": "머신 카프 레이즈",
    "smith-machine-squat": "스미스 머신 스쿼트",
    "machine-shoulder-press": "머신 숄더 프레스",
    "pec-deck": "펙 덱",
    "leg-press-horizontal": "수평 레그 프레스",
    "lying-leg-curl": "라잉 레그 컬",
    "machine-row": "머신 로우",
    "hip-abduction": "힙 어브덕션",
    "hip-adduction": "힙 어덕션",
    "assisted-pull-up": "어시스티드 풀업",
    "smith-bench-press": "스미스 벤치 프레스",
    "reverse-hyper": "리버스 하이퍼",
    "glute-ham-raise": "글루트 햄 레이즈",
    "belt-squat": "벨트 스쿼트",
    "lat-pulldown": "랫 풀다운",
    "tricep-pushdown": "트라이셉 푸시다운",
    "seated-cable-row": "시티드 케이블 로우",
    "cable-fly": "케이블 플라이",
    "face-pull": "페이스 풀",
    "cable-curl": "케이블 컬",
    "cable-lateral-raise": "케이블 레터럴 레이즈",
    "cable-kickback": "케이블 킥백",
    "cable-crunch": "케이블 크런치",
    "cable-woodchop": "케이블 우드찹",
    "cable-pull-through": "케이블 풀스루",
    "cable-overhead-ext": "케이블 오버헤드 익스텐션",
    "cable-upright-row": "케이블 업라이트 로우",
    "cable-reverse-fly": "케이블 리버스 플라이",
    "cable-pullover": "케이블 풀오버",
    "barbell-upright-row": "바벨 업라이트 로우",
    "landmine-press": "랜드마인 프레스",
    "landmine-row": "랜드마인 로우",
    "barbell-hack-squat": "바벨 핵 스쿼트",
    "jefferson-squat": "제퍼슨 스쿼트",
    "barbell-hip-thrust": "바벨 글루트 브릿지",
    "z-press": "Z 프레스",
    "spoto-press": "스포토 프레스",
    "pin-squat": "핀 스쿼트",
    "snatch-grip-deadlift": "스내치 그립 데드리프트",
    "trap-bar-deadlift": "트랩바 데드리프트",
    "barbell-calf-raise": "바벨 카프 레이즈",
    "barbell-pullover": "바벨 풀오버",
    "viking-press": "바이킹 프레스",
    "larsen-press": "라센 프레스",
    "single-leg-squat": "싱글 레그 스쿼트",
    "ring-dips": "링 딥스",
    "ring-muscle-up": "링 머슬업",
    "toes-to-bar": "토즈 투 바",
    "russian-twist": "러시안 트위스트",
    "pike-push-up": "파이크 푸시업",
    "ab-wheel-rollout": "앱 휠 롤아웃",
    "plank": "플랭크",
    "box-jump": "박스 점프",
    "glute-bridge": "글루트 브릿지",
    "dumbbell-snatch": "덤벨 스내치",
    "dumbbell-clean": "덤벨 클린",
    "dumbbell-thruster": "덤벨 쓰러스터",
    "dumbbell-floor-press": "덤벨 플로어 프레스",
    "dumbbell-hip-thrust": "덤벨 힙 쓰러스트",
    "renegade-row": "레니게이드 로우",
    "dumbbell-clean-press": "덤벨 클린 앤 프레스",
    "zottman-curl": "조트만 컬",
    "spider-curl": "스파이더 컬",
    "dumbbell-wrist-curl": "덤벨 리스트 컬",
    "leg-press-single": "싱글 레그 프레스",
    "smith-shoulder-press": "스미스 숄더 프레스",
    "smith-squat-split": "스미스 스플릿 스쿼트",
    "pendulum-squat": "펜듈럼 스쿼트",
    "seated-calf-raise": "시티드 카프 레이즈",
    "machine-lat-raise": "머신 레터럴 레이즈",
    "machine-bicep-curl": "머신 바이셉 컬",
    "machine-tricep-ext": "머신 트라이셉 익스텐션",
    "machine-rear-delt": "머신 리어 델트 플라이",
    "standing-calf-raise": "스탠딩 카프 레이즈 머신",
    "cable-hammer-curl": "케이블 해머 컬",
    "cable-chest-press": "케이블 체스트 프레스",
    "straight-arm-pulldown": "스트레이트 암 풀다운",
    "cable-hip-abduction": "케이블 힙 어브덕션",
    "cable-shrug": "케이블 슈러그",
    "bayesian-curl": "베이지안 컬",
    "cable-front-raise": "케이블 프론트 레이즈",
    "pallof-press": "팔로프 프레스",
    "cable-crossover": "케이블 크로스오버",
    "cable-tricep-kickback": "케이블 트라이셉 킥백",
    "cable-external-rotation": "케이블 외회전",
    "cable-internal-rotation": "케이블 내회전",
    "board-press": "보드 프레스",
    "box-squat": "박스 스쿼트",
    "safety-bar-squat": "세이프티 바 스쿼트",
    "block-pull": "블록 풀",
    "tempo-squat": "템포 스쿼트",
    "sots-press": "소츠 프레스",
    "hang-clean": "행 클린",
    "hang-snatch": "행 스내치",
    "split-jerk": "스플릿 저크",
    "clean-pull": "클린 풀",
    "snatch-pull": "스내치 풀",
    "barbell-drag-curl": "바벨 드래그 컬",
    "reverse-barbell-curl": "리버스 바벨 컬",
    "barbell-spider-curl": "바벨 스파이더 컬",
    "jm-press": "JM 프레스",
    "dumbbell-power-clean": "덤벨 파워 클린",
    "dumbbell-swing": "덤벨 스윙",
    "dumbbell-split-squat": "덤벨 스플릿 스쿼트",
    "dumbbell-incline-fly": "덤벨 인클라인 플라이",
    "dumbbell-decline-press": "덤벨 디클라인 프레스",
    "dumbbell-upright-row": "덤벨 업라이트 로우",
    "single-arm-db-press": "싱글 암 덤벨 프레스",
    "dumbbell-pullover-incline": "인클라인 덤벨 풀오버",
    "dumbbell-kickback": "덤벨 트라이셉 킥백",
    "dumbbell-rear-lunge": "덤벨 리버스 런지",
    "smith-incline-press": "스미스 인클라인 프레스",
    "smith-romanian-dl": "스미스 루마니안 데드리프트",
    "smith-calf-raise": "스미스 카프 레이즈",
    "machine-chest-fly": "머신 체스트 플라이",
    "machine-pullover": "머신 풀오버",
    "machine-back-ext": "머신 백 익스텐션",
    "machine-ab-crunch": "머신 앱 크런치",
    "machine-preacher-curl": "머신 프리처 컬",
    "v-squat": "V 스쿼트",
    "sissy-squat-machine": "시시 스쿼트 머신",
    "wall-sit": "월 싯",
    "superman": "슈퍼맨",
    "bear-crawl": "베어 크롤",
    "mountain-climber": "마운틴 클라이머",
    "cossack-squat": "코사크 스쿼트",
    "decline-push-up": "디클라인 푸시업",
    "diamond-push-up": "다이아몬드 푸시업",
    "archer-push-up": "아처 푸시업",
    "skin-the-cat": "스킨 더 캣",
    "human-flag": "휴먼 플래그",
    "wrist-curl": "리스트 컬",
    "reverse-wrist-curl": "리버스 리스트 컬",
    "farmers-walk": "파머스 워크",
    "plate-pinch": "플레이트 핀치",
    "behind-back-wrist-curl": "비하인드 백 리스트 컬",
    "dead-hang": "데드 행",
    "running-1-mile": "1마일 (1.6km) 달리기",
    "running-5k": "5km 달리기",
    "running-10k": "10km 달리기",
    "rowing-500m": "500m 로잉",
    "rowing-2000m": "2000m 로잉",
    "cycling-10k": "10km 사이클링",
    "jump-rope-1min": "줄넘기 (1분)",
    "swimming-100m": "100m 수영",
    "stair-climber-10min": "스테어 클라이머 (10분)",
    "battle-ropes-1min": "배틀 로프 (1분)",
    "assault-bike-cal-1min": "어솔트 바이크 (1분 칼로리)",
    "sled-push-40yd": "슬레드 푸시 (40야드)"
  },
  es: {
    "bench-press": "Press de Banca",
    "squat": "Sentadilla",
    "deadlift": "Peso Muerto",
    "shoulder-press": "Press de Hombros",
    "barbell-curl": "Curl con Barra",
    "bent-over-row": "Remo Inclinado",
    "incline-bench-press": "Press de Banca Inclinado",
    "front-squat": "Sentadilla Frontal",
    "romanian-deadlift": "Peso Muerto Rumano",
    "hip-thrust": "Empuje de Cadera",
    "power-clean": "Cargada de Potencia",
    "close-grip-bench": "Press de Banca Agarre Cerrado",
    "lying-tricep-ext": "Extensión de Tríceps Acostado",
    "barbell-shrug": "Encogimiento con Barra",
    "ez-bar-curl": "Curl con Barra EZ",
    "overhead-press": "Press por Encima de la Cabeza",
    "sumo-deadlift": "Peso Muerto Sumo",
    "pendlay-row": "Remo Pendlay",
    "barbell-lunge": "Zancada con Barra",
    "deficit-deadlift": "Peso Muerto con Déficit",
    "floor-press": "Press de Piso",
    "zercher-squat": "Sentadilla Zercher",
    "snatch": "Arranque",
    "clean-and-jerk": "Cargada y Envión",
    "good-morning": "Buenos Días",
    "rack-pull": "Tirón desde Rack",
    "push-press": "Press con Empuje",
    "decline-bench-press": "Press de Banca Declinado",
    "t-bar-row": "Remo en T",
    "pause-squat": "Sentadilla con Pausa",
    "stiff-leg-deadlift": "Peso Muerto con Piernas Rígidas",
    "behind-neck-press": "Press tras Nuca",
    "preacher-curl": "Curl en Banco Scott",
    "skull-crusher": "Rompecráneos",
    "pull-ups": "Dominadas",
    "push-ups": "Flexiones",
    "dips": "Fondos",
    "chin-ups": "Dominadas Supinas",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Abdominales",
    "pistol-squat": "Sentadilla Pistol",
    "handstand-push-up": "Flexión en Pino",
    "planche": "Plancha",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Elevación de Piernas Colgado",
    "burpees": "Burpees",
    "inverted-row": "Remo Invertido",
    "dragon-flag": "Bandera del Dragón",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Curl Nórdico",
    "dumbbell-bench-press": "Press de Banca con Mancuernas",
    "dumbbell-curl": "Curl con Mancuerna",
    "incline-db-bench": "Press Inclinado con Mancuernas",
    "dumbbell-shoulder-press": "Press de Hombros con Mancuerna",
    "dumbbell-lateral-raise": "Elevación Lateral con Mancuerna",
    "dumbbell-row": "Remo con Mancuerna",
    "hammer-curl": "Curl Martillo",
    "goblet-squat": "Sentadilla Goblet",
    "dumbbell-fly": "Aperturas con Mancuerna",
    "dumbbell-pullover": "Pullover con Mancuerna",
    "dumbbell-lunge": "Zancada con Mancuerna",
    "dumbbell-shrug": "Encogimiento con Mancuerna",
    "concentration-curl": "Curl Concentrado",
    "dumbbell-tricep-ext": "Extensión de Tríceps con Mancuerna",
    "dumbbell-reverse-fly": "Apertura Inversa con Mancuerna",
    "arnold-press": "Press Arnold",
    "dumbbell-front-raise": "Elevación Frontal con Mancuerna",
    "dumbbell-romanian-dl": "Peso Muerto Rumano con Mancuerna",
    "dumbbell-step-up": "Step Up con Mancuerna",
    "dumbbell-skull-crusher": "Rompecráneos con Mancuerna",
    "incline-dumbbell-curl": "Curl Inclinado con Mancuerna",
    "dumbbell-calf-raise": "Elevación de Pantorrilla con Mancuerna",
    "sled-leg-press": "Prensa de Piernas",
    "leg-extension": "Extensión de Piernas",
    "chest-press": "Press de Pecho en Máquina",
    "hack-squat": "Sentadilla Hack",
    "seated-leg-curl": "Curl de Piernas Sentado",
    "machine-calf-raise": "Elevación de Pantorrilla en Máquina",
    "smith-machine-squat": "Sentadilla en Máquina Smith",
    "machine-shoulder-press": "Press de Hombros en Máquina",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Prensa de Piernas Horizontal",
    "lying-leg-curl": "Curl de Piernas Acostado",
    "machine-row": "Remo en Máquina",
    "hip-abduction": "Abducción de Cadera",
    "hip-adduction": "Aducción de Cadera",
    "assisted-pull-up": "Dominada Asistida",
    "smith-bench-press": "Press de Banca Smith",
    "reverse-hyper": "Hiperextensión Inversa",
    "glute-ham-raise": "Elevación Glúteo-Isquiotibial",
    "belt-squat": "Sentadilla con Cinturón",
    "lat-pulldown": "Jalón al Pecho",
    "tricep-pushdown": "Empuje de Tríceps",
    "seated-cable-row": "Remo con Cable Sentado",
    "cable-fly": "Apertura con Cable",
    "face-pull": "Face Pull",
    "cable-curl": "Curl con Cable",
    "cable-lateral-raise": "Elevación Lateral con Cable",
    "cable-kickback": "Patada con Cable",
    "cable-crunch": "Crunch con Cable",
    "cable-woodchop": "Leñador con Cable",
    "cable-pull-through": "Tirón entre Piernas con Cable",
    "cable-overhead-ext": "Extensión sobre Cabeza con Cable",
    "cable-upright-row": "Remo al Mentón con Cable",
    "cable-reverse-fly": "Apertura Inversa con Cable",
    "cable-pullover": "Pullover con Cable",
    "barbell-upright-row": "Remo al Mentón con Barra",
    "landmine-press": "Press Landmine",
    "landmine-row": "Remo Landmine",
    "barbell-hack-squat": "Sentadilla Hack con Barra",
    "jefferson-squat": "Sentadilla Jefferson",
    "barbell-hip-thrust": "Puente de Glúteos con Barra",
    "z-press": "Z Press",
    "spoto-press": "Press Spoto",
    "pin-squat": "Sentadilla desde Pins",
    "snatch-grip-deadlift": "Peso Muerto Agarre Arranque",
    "trap-bar-deadlift": "Peso Muerto con Barra Hexagonal",
    "barbell-calf-raise": "Elevación de Pantorrilla con Barra",
    "barbell-pullover": "Pullover con Barra",
    "viking-press": "Press Vikingo",
    "larsen-press": "Press Larsen",
    "single-leg-squat": "Sentadilla a Una Pierna",
    "ring-dips": "Fondos en Anillas",
    "ring-muscle-up": "Muscle Up en Anillas",
    "toes-to-bar": "Pies a la Barra",
    "russian-twist": "Giro Ruso",
    "pike-push-up": "Flexión Pike",
    "ab-wheel-rollout": "Rueda Abdominal",
    "plank": "Plancha Isométrica",
    "box-jump": "Salto al Cajón",
    "glute-bridge": "Puente de Glúteos",
    "dumbbell-snatch": "Arranque con Mancuerna",
    "dumbbell-clean": "Cargada con Mancuerna",
    "dumbbell-thruster": "Thruster con Mancuerna",
    "dumbbell-floor-press": "Press de Piso con Mancuerna",
    "dumbbell-hip-thrust": "Empuje de Cadera con Mancuerna",
    "renegade-row": "Remo Renegado",
    "dumbbell-clean-press": "Cargada y Press con Mancuerna",
    "zottman-curl": "Curl Zottman",
    "spider-curl": "Curl Araña",
    "dumbbell-wrist-curl": "Curl de Muñeca con Mancuerna",
    "leg-press-single": "Prensa de Pierna Unilateral",
    "smith-shoulder-press": "Press de Hombros Smith",
    "smith-squat-split": "Sentadilla Búlgara Smith",
    "pendulum-squat": "Sentadilla Péndulo",
    "seated-calf-raise": "Elevación de Pantorrilla Sentado",
    "machine-lat-raise": "Elevación Lateral en Máquina",
    "machine-bicep-curl": "Curl de Bíceps en Máquina",
    "machine-tricep-ext": "Extensión de Tríceps en Máquina",
    "machine-rear-delt": "Deltoides Posterior en Máquina",
    "standing-calf-raise": "Elevación de Pantorrilla de Pie",
    "cable-hammer-curl": "Curl Martillo con Cable",
    "cable-chest-press": "Press de Pecho con Cable",
    "straight-arm-pulldown": "Jalón con Brazos Rectos",
    "cable-hip-abduction": "Abducción de Cadera con Cable",
    "cable-shrug": "Encogimiento con Cable",
    "bayesian-curl": "Curl Bayesiano",
    "cable-front-raise": "Elevación Frontal con Cable",
    "pallof-press": "Press Pallof",
    "cable-crossover": "Cruce de Cables",
    "cable-tricep-kickback": "Patada de Tríceps con Cable",
    "cable-external-rotation": "Rotación Externa con Cable",
    "cable-internal-rotation": "Rotación Interna con Cable",
    "board-press": "Press con Tabla",
    "box-squat": "Sentadilla al Cajón",
    "safety-bar-squat": "Sentadilla con Barra de Seguridad",
    "block-pull": "Tirón desde Bloques",
    "tempo-squat": "Sentadilla con Tempo",
    "sots-press": "Press Sots",
    "hang-clean": "Cargada Colgante",
    "hang-snatch": "Arranque Colgante",
    "split-jerk": "Envión con Split",
    "clean-pull": "Tirón de Cargada",
    "snatch-pull": "Tirón de Arranque",
    "barbell-drag-curl": "Curl de Arrastre con Barra",
    "reverse-barbell-curl": "Curl Inverso con Barra",
    "barbell-spider-curl": "Curl Araña con Barra",
    "jm-press": "Press JM",
    "dumbbell-power-clean": "Cargada de Potencia con Mancuerna",
    "dumbbell-swing": "Swing con Mancuerna",
    "dumbbell-split-squat": "Sentadilla Búlgara con Mancuerna",
    "dumbbell-incline-fly": "Apertura Inclinada con Mancuerna",
    "dumbbell-decline-press": "Press Declinado con Mancuerna",
    "dumbbell-upright-row": "Remo al Mentón con Mancuerna",
    "single-arm-db-press": "Press con Mancuerna a Un Brazo",
    "dumbbell-pullover-incline": "Pullover Inclinado con Mancuerna",
    "dumbbell-kickback": "Patada de Tríceps con Mancuerna",
    "dumbbell-rear-lunge": "Zancada Inversa con Mancuerna",
    "smith-incline-press": "Press Inclinado Smith",
    "smith-romanian-dl": "Peso Muerto Rumano Smith",
    "smith-calf-raise": "Elevación de Pantorrilla Smith",
    "machine-chest-fly": "Apertura de Pecho en Máquina",
    "machine-pullover": "Pullover en Máquina",
    "machine-back-ext": "Extensión de Espalda en Máquina",
    "machine-ab-crunch": "Crunch Abdominal en Máquina",
    "machine-preacher-curl": "Curl Scott en Máquina",
    "v-squat": "Sentadilla en V",
    "sissy-squat-machine": "Sentadilla Sissy en Máquina",
    "wall-sit": "Sentadilla en Pared",
    "superman": "Superman",
    "bear-crawl": "Caminata de Oso",
    "mountain-climber": "Escaladores",
    "cossack-squat": "Sentadilla Cosaca",
    "decline-push-up": "Flexión Declinada",
    "diamond-push-up": "Flexión Diamante",
    "archer-push-up": "Flexión Arquero",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Bandera Humana",
    "wrist-curl": "Curl de Muñeca",
    "reverse-wrist-curl": "Curl de Muñeca Inverso",
    "farmers-walk": "Caminata del Granjero",
    "plate-pinch": "Pinza de Disco",
    "behind-back-wrist-curl": "Curl de Muñeca tras Espalda",
    "dead-hang": "Colgarse Pasivo",
    "running-1-mile": "Carrera 1 Milla (1.6km)",
    "running-5k": "Carrera 5K",
    "running-10k": "Carrera 10K",
    "rowing-500m": "Remo 500m",
    "rowing-2000m": "Remo 2000m",
    "cycling-10k": "Ciclismo 10K",
    "jump-rope-1min": "Saltar la Cuerda (1 min)",
    "swimming-100m": "Natación 100m",
    "stair-climber-10min": "Escaladora (10 min)",
    "battle-ropes-1min": "Cuerdas de Batalla (1 min)",
    "assault-bike-cal-1min": "Assault Bike (1 min cal)",
    "sled-push-40yd": "Empuje de Trineo (40 yd)"
  },
  fr: {
    "bench-press": "Développé Couché",
    "squat": "Squat",
    "deadlift": "Soulevé de Terre",
    "shoulder-press": "Développé Épaules",
    "barbell-curl": "Curl à la Barre",
    "bent-over-row": "Rowing Buste Penché",
    "incline-bench-press": "Développé Incliné",
    "front-squat": "Squat Avant",
    "romanian-deadlift": "Soulevé de Terre Roumain",
    "hip-thrust": "Hip Thrust",
    "power-clean": "Épaulé en Puissance",
    "close-grip-bench": "Développé Couché Prise Serrée",
    "lying-tricep-ext": "Extension Triceps Allongé",
    "barbell-shrug": "Haussement d'Épaules à la Barre",
    "ez-bar-curl": "Curl Barre EZ",
    "overhead-press": "Développé Militaire",
    "sumo-deadlift": "Soulevé de Terre Sumo",
    "pendlay-row": "Rowing Pendlay",
    "barbell-lunge": "Fente à la Barre",
    "deficit-deadlift": "Soulevé de Terre en Déficit",
    "floor-press": "Développé au Sol",
    "zercher-squat": "Squat Zercher",
    "snatch": "Arraché",
    "clean-and-jerk": "Épaulé-Jeté",
    "good-morning": "Good Morning",
    "rack-pull": "Tirage au Rack",
    "push-press": "Push Press",
    "decline-bench-press": "Développé Décliné",
    "t-bar-row": "Rowing en T",
    "pause-squat": "Squat avec Pause",
    "stiff-leg-deadlift": "Soulevé de Terre Jambes Tendues",
    "behind-neck-press": "Développé Nuque",
    "preacher-curl": "Curl au Pupitre",
    "skull-crusher": "Briseur de Crâne",
    "pull-ups": "Tractions",
    "push-ups": "Pompes",
    "dips": "Dips",
    "chin-ups": "Tractions Supination",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Relevés de Buste",
    "pistol-squat": "Squat Pistol",
    "handstand-push-up": "Pompe en Équilibre",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Relevé de Jambes Suspendu",
    "burpees": "Burpees",
    "inverted-row": "Rowing Inversé",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Curl Nordique",
    "dumbbell-bench-press": "Développé Couché aux Haltères",
    "dumbbell-curl": "Curl aux Haltères",
    "incline-db-bench": "Développé Incliné aux Haltères",
    "dumbbell-shoulder-press": "Développé Épaules aux Haltères",
    "dumbbell-lateral-raise": "Élévation Latérale aux Haltères",
    "dumbbell-row": "Rowing aux Haltères",
    "hammer-curl": "Curl Marteau",
    "goblet-squat": "Squat Goblet",
    "dumbbell-fly": "Écarté aux Haltères",
    "dumbbell-pullover": "Pullover aux Haltères",
    "dumbbell-lunge": "Fente aux Haltères",
    "dumbbell-shrug": "Haussement aux Haltères",
    "concentration-curl": "Curl Concentré",
    "dumbbell-tricep-ext": "Extension Triceps aux Haltères",
    "dumbbell-reverse-fly": "Écarté Inversé aux Haltères",
    "arnold-press": "Développé Arnold",
    "dumbbell-front-raise": "Élévation Frontale aux Haltères",
    "dumbbell-romanian-dl": "Soulevé Roumain aux Haltères",
    "dumbbell-step-up": "Step Up aux Haltères",
    "dumbbell-skull-crusher": "Briseur de Crâne aux Haltères",
    "incline-dumbbell-curl": "Curl Incliné aux Haltères",
    "dumbbell-calf-raise": "Élévation Mollets aux Haltères",
    "sled-leg-press": "Presse à Cuisses",
    "leg-extension": "Extension des Jambes",
    "chest-press": "Presse Pectorale",
    "hack-squat": "Squat Hack",
    "seated-leg-curl": "Curl des Jambes Assis",
    "machine-calf-raise": "Élévation Mollets Machine",
    "smith-machine-squat": "Squat Smith Machine",
    "machine-shoulder-press": "Développé Épaules Machine",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Presse Horizontale",
    "lying-leg-curl": "Curl des Jambes Allongé",
    "machine-row": "Rowing Machine",
    "hip-abduction": "Abduction de Hanche",
    "hip-adduction": "Adduction de Hanche",
    "assisted-pull-up": "Traction Assistée",
    "smith-bench-press": "Développé Couché Smith",
    "reverse-hyper": "Hyper Extension Inversée",
    "glute-ham-raise": "Relevé Fessier-Ischio",
    "belt-squat": "Squat à Ceinture",
    "lat-pulldown": "Tirage Vertical",
    "tricep-pushdown": "Poussée Triceps",
    "seated-cable-row": "Rowing Câble Assis",
    "cable-fly": "Écarté au Câble",
    "face-pull": "Face Pull",
    "cable-curl": "Curl au Câble",
    "cable-lateral-raise": "Élévation Latérale au Câble",
    "cable-kickback": "Kickback au Câble",
    "cable-crunch": "Crunch au Câble",
    "cable-woodchop": "Bûcheron au Câble",
    "cable-pull-through": "Pull Through au Câble",
    "cable-overhead-ext": "Extension au-dessus de la Tête au Câble",
    "cable-upright-row": "Rowing Menton au Câble",
    "cable-reverse-fly": "Écarté Inversé au Câble",
    "cable-pullover": "Pullover au Câble",
    "barbell-upright-row": "Rowing Menton à la Barre",
    "landmine-press": "Press Landmine",
    "landmine-row": "Rowing Landmine",
    "barbell-hack-squat": "Squat Hack à la Barre",
    "jefferson-squat": "Squat Jefferson",
    "barbell-hip-thrust": "Pont Fessier à la Barre",
    "z-press": "Z Press",
    "spoto-press": "Développé Spoto",
    "pin-squat": "Squat aux Pins",
    "snatch-grip-deadlift": "Soulevé Prise Arraché",
    "trap-bar-deadlift": "Soulevé Barre Hexagonale",
    "barbell-calf-raise": "Élévation Mollets à la Barre",
    "barbell-pullover": "Pullover à la Barre",
    "viking-press": "Développé Viking",
    "larsen-press": "Développé Larsen",
    "single-leg-squat": "Squat Unipodal",
    "ring-dips": "Dips aux Anneaux",
    "ring-muscle-up": "Muscle Up aux Anneaux",
    "toes-to-bar": "Orteils à la Barre",
    "russian-twist": "Rotation Russe",
    "pike-push-up": "Pompe Pike",
    "ab-wheel-rollout": "Roue Abdominale",
    "plank": "Gainage",
    "box-jump": "Saut sur Caisse",
    "glute-bridge": "Pont Fessier",
    "dumbbell-snatch": "Arraché aux Haltères",
    "dumbbell-clean": "Épaulé aux Haltères",
    "dumbbell-thruster": "Thruster aux Haltères",
    "dumbbell-floor-press": "Développé au Sol aux Haltères",
    "dumbbell-hip-thrust": "Hip Thrust aux Haltères",
    "renegade-row": "Rowing Renégat",
    "dumbbell-clean-press": "Épaulé-Jeté aux Haltères",
    "zottman-curl": "Curl Zottman",
    "spider-curl": "Curl Araignée",
    "dumbbell-wrist-curl": "Curl Poignet aux Haltères",
    "leg-press-single": "Presse Unipodal",
    "smith-shoulder-press": "Développé Épaules Smith",
    "smith-squat-split": "Squat Bulgare Smith",
    "pendulum-squat": "Squat Pendulaire",
    "seated-calf-raise": "Élévation Mollets Assis",
    "machine-lat-raise": "Élévation Latérale Machine",
    "machine-bicep-curl": "Curl Biceps Machine",
    "machine-tricep-ext": "Extension Triceps Machine",
    "machine-rear-delt": "Deltoïde Postérieur Machine",
    "standing-calf-raise": "Élévation Mollets Debout",
    "cable-hammer-curl": "Curl Marteau au Câble",
    "cable-chest-press": "Presse Pectorale au Câble",
    "straight-arm-pulldown": "Tirage Bras Tendus",
    "cable-hip-abduction": "Abduction Hanche au Câble",
    "cable-shrug": "Haussement au Câble",
    "bayesian-curl": "Curl Bayésien",
    "cable-front-raise": "Élévation Frontale au Câble",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Croisement de Câbles",
    "cable-tricep-kickback": "Kickback Triceps au Câble",
    "cable-external-rotation": "Rotation Externe au Câble",
    "cable-internal-rotation": "Rotation Interne au Câble",
    "board-press": "Développé avec Planche",
    "box-squat": "Squat sur Caisse",
    "safety-bar-squat": "Squat Barre de Sécurité",
    "block-pull": "Tirage depuis Blocs",
    "tempo-squat": "Squat Tempo",
    "sots-press": "Développé Sots",
    "hang-clean": "Épaulé Suspendu",
    "hang-snatch": "Arraché Suspendu",
    "split-jerk": "Jeté en Fente",
    "clean-pull": "Tirage d'Épaulé",
    "snatch-pull": "Tirage d'Arraché",
    "barbell-drag-curl": "Curl de Traînée à la Barre",
    "reverse-barbell-curl": "Curl Inversé à la Barre",
    "barbell-spider-curl": "Curl Araignée à la Barre",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "Épaulé Puissance aux Haltères",
    "dumbbell-swing": "Swing aux Haltères",
    "dumbbell-split-squat": "Squat Bulgare aux Haltères",
    "dumbbell-incline-fly": "Écarté Incliné aux Haltères",
    "dumbbell-decline-press": "Développé Décliné aux Haltères",
    "dumbbell-upright-row": "Rowing Menton aux Haltères",
    "single-arm-db-press": "Développé Unilatéral aux Haltères",
    "dumbbell-pullover-incline": "Pullover Incliné aux Haltères",
    "dumbbell-kickback": "Kickback Triceps aux Haltères",
    "dumbbell-rear-lunge": "Fente Arrière aux Haltères",
    "smith-incline-press": "Développé Incliné Smith",
    "smith-romanian-dl": "Soulevé Roumain Smith",
    "smith-calf-raise": "Élévation Mollets Smith",
    "machine-chest-fly": "Écarté Pectoral Machine",
    "machine-pullover": "Pullover Machine",
    "machine-back-ext": "Extension du Dos Machine",
    "machine-ab-crunch": "Crunch Abdominal Machine",
    "machine-preacher-curl": "Curl au Pupitre Machine",
    "v-squat": "Squat en V",
    "sissy-squat-machine": "Sissy Squat Machine",
    "wall-sit": "Chaise",
    "superman": "Superman",
    "bear-crawl": "Marche de l'Ours",
    "mountain-climber": "Grimpeurs",
    "cossack-squat": "Squat Cosaque",
    "decline-push-up": "Pompe Déclinée",
    "diamond-push-up": "Pompe Diamant",
    "archer-push-up": "Pompe Archer",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Drapeau Humain",
    "wrist-curl": "Curl Poignet",
    "reverse-wrist-curl": "Curl Poignet Inversé",
    "farmers-walk": "Marche du Fermier",
    "plate-pinch": "Pince de Disque",
    "behind-back-wrist-curl": "Curl Poignet derrière le Dos",
    "dead-hang": "Suspension Passive",
    "running-1-mile": "Course 1 Mile (1.6km)",
    "running-5k": "Course 5K",
    "running-10k": "Course 10K",
    "rowing-500m": "Rameur 500m",
    "rowing-2000m": "Rameur 2000m",
    "cycling-10k": "Cyclisme 10K",
    "jump-rope-1min": "Corde à Sauter (1 min)",
    "swimming-100m": "Natation 100m",
    "stair-climber-10min": "Escalier (10 min)",
    "battle-ropes-1min": "Cordes de Combat (1 min)",
    "assault-bike-cal-1min": "Assault Bike (1 min cal)",
    "sled-push-40yd": "Poussée de Traîneau (40 yd)"
  },
  de: {
    "bench-press": "Bankdrücken",
    "squat": "Kniebeuge",
    "deadlift": "Kreuzheben",
    "shoulder-press": "Schulterdrücken",
    "barbell-curl": "Langhantelcurl",
    "bent-over-row": "Vorgebeugtes Rudern",
    "incline-bench-press": "Schrägbankdrücken",
    "front-squat": "Frontkniebeuge",
    "romanian-deadlift": "Rumänisches Kreuzheben",
    "hip-thrust": "Hip Thrust",
    "power-clean": "Umsetzen",
    "close-grip-bench": "Enggriff-Bankdrücken",
    "lying-tricep-ext": "Liegende Trizepsstreckung",
    "barbell-shrug": "Langhantel-Schulterheben",
    "ez-bar-curl": "SZ-Stangen-Curl",
    "overhead-press": "Überkopfdrücken",
    "sumo-deadlift": "Sumo-Kreuzheben",
    "pendlay-row": "Pendlay-Rudern",
    "barbell-lunge": "Langhantel-Ausfallschritt",
    "deficit-deadlift": "Defizit-Kreuzheben",
    "floor-press": "Bodendrücken",
    "zercher-squat": "Zercher-Kniebeuge",
    "snatch": "Reißen",
    "clean-and-jerk": "Stoßen",
    "good-morning": "Good Morning",
    "rack-pull": "Rack Pull",
    "push-press": "Stoßdrücken",
    "decline-bench-press": "Negativ-Bankdrücken",
    "t-bar-row": "T-Bar-Rudern",
    "pause-squat": "Pausen-Kniebeuge",
    "stiff-leg-deadlift": "Gestrecktes Kreuzheben",
    "behind-neck-press": "Nackendrücken",
    "preacher-curl": "Preacher-Curl",
    "skull-crusher": "Skull Crusher",
    "pull-ups": "Klimmzüge",
    "push-ups": "Liegestütze",
    "dips": "Dips",
    "chin-ups": "Klimmzüge im Untergriff",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Sit-Ups",
    "pistol-squat": "Pistol Squat",
    "handstand-push-up": "Handstand-Liegestütz",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Hängendes Beinheben",
    "burpees": "Burpees",
    "inverted-row": "Invertiertes Rudern",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sitz",
    "back-lever": "Back Lever",
    "nordic-curl": "Nordischer Curl",
    "dumbbell-bench-press": "Kurzhantel-Bankdrücken",
    "dumbbell-curl": "Kurzhantelcurl",
    "incline-db-bench": "Schrägbank-Kurzhanteldrücken",
    "dumbbell-shoulder-press": "Kurzhantel-Schulterdrücken",
    "dumbbell-lateral-raise": "Kurzhantel-Seitheben",
    "dumbbell-row": "Kurzhantel-Rudern",
    "hammer-curl": "Hammercurl",
    "goblet-squat": "Goblet Squat",
    "dumbbell-fly": "Kurzhantel-Flys",
    "dumbbell-pullover": "Kurzhantel-Pullover",
    "dumbbell-lunge": "Kurzhantel-Ausfallschritt",
    "dumbbell-shrug": "Kurzhantel-Schulterheben",
    "concentration-curl": "Konzentrationscurl",
    "dumbbell-tricep-ext": "Kurzhantel-Trizepsstreckung",
    "dumbbell-reverse-fly": "Kurzhantel-Reverse-Fly",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "Kurzhantel-Frontheben",
    "dumbbell-romanian-dl": "Kurzhantel-Rumänisches Kreuzheben",
    "dumbbell-step-up": "Kurzhantel Step Up",
    "dumbbell-skull-crusher": "Kurzhantel Skull Crusher",
    "incline-dumbbell-curl": "Schrägbank-Kurzhantelcurl",
    "dumbbell-calf-raise": "Kurzhantel-Wadenheben",
    "sled-leg-press": "Beinpresse",
    "leg-extension": "Beinstrecker",
    "chest-press": "Brustpresse",
    "hack-squat": "Hackenschmidt-Kniebeuge",
    "seated-leg-curl": "Sitzender Beincurl",
    "machine-calf-raise": "Maschinen-Wadenheben",
    "smith-machine-squat": "Smith-Kniebeuge",
    "machine-shoulder-press": "Maschinen-Schulterdrücken",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Horizontale Beinpresse",
    "lying-leg-curl": "Liegender Beincurl",
    "machine-row": "Maschinen-Rudern",
    "hip-abduction": "Hüftabduktion",
    "hip-adduction": "Hüftadduktion",
    "assisted-pull-up": "Unterstützter Klimmzug",
    "smith-bench-press": "Smith-Bankdrücken",
    "reverse-hyper": "Reverse Hyper",
    "glute-ham-raise": "Gluteus-Ham-Raise",
    "belt-squat": "Gürtel-Kniebeuge",
    "lat-pulldown": "Latzug",
    "tricep-pushdown": "Trizepsdrücken am Kabel",
    "seated-cable-row": "Sitzendes Kabelrudern",
    "cable-fly": "Kabel-Flys",
    "face-pull": "Face Pull",
    "cable-curl": "Kabelcurl",
    "cable-lateral-raise": "Kabel-Seitheben",
    "cable-kickback": "Kabel-Kickback",
    "cable-crunch": "Kabel-Crunch",
    "cable-woodchop": "Kabel-Holzhacker",
    "cable-pull-through": "Kabel-Pull-Through",
    "cable-overhead-ext": "Kabel-Überkopfstreckung",
    "cable-upright-row": "Kabel-Aufrecht-Rudern",
    "cable-reverse-fly": "Kabel-Reverse-Fly",
    "cable-pullover": "Kabel-Pullover",
    "barbell-upright-row": "Langhantel-Aufrecht-Rudern",
    "landmine-press": "Landmine Press",
    "landmine-row": "Landmine-Rudern",
    "barbell-hack-squat": "Langhantel-Hackenschmidt",
    "jefferson-squat": "Jefferson-Kniebeuge",
    "barbell-hip-thrust": "Langhantel-Glute-Bridge",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Pin Squat",
    "snatch-grip-deadlift": "Reißgriff-Kreuzheben",
    "trap-bar-deadlift": "Trap-Bar-Kreuzheben",
    "barbell-calf-raise": "Langhantel-Wadenheben",
    "barbell-pullover": "Langhantel-Pullover",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Einbeinige Kniebeuge",
    "ring-dips": "Ring-Dips",
    "ring-muscle-up": "Ring-Muscle-Up",
    "toes-to-bar": "Zehen zur Stange",
    "russian-twist": "Russischer Twist",
    "pike-push-up": "Pike-Liegestütz",
    "ab-wheel-rollout": "Ab-Wheel-Rollout",
    "plank": "Unterarmstütz",
    "box-jump": "Kastensprung",
    "glute-bridge": "Glute Bridge",
    "dumbbell-snatch": "Kurzhantel-Reißen",
    "dumbbell-clean": "Kurzhantel-Umsetzen",
    "dumbbell-thruster": "Kurzhantel-Thruster",
    "dumbbell-floor-press": "Kurzhantel-Bodendrücken",
    "dumbbell-hip-thrust": "Kurzhantel-Hip-Thrust",
    "renegade-row": "Renegade-Rudern",
    "dumbbell-clean-press": "Kurzhantel Umsetzen & Drücken",
    "zottman-curl": "Zottman-Curl",
    "spider-curl": "Spider-Curl",
    "dumbbell-wrist-curl": "Kurzhantel-Handgelenkscurl",
    "leg-press-single": "Einbeinige Beinpresse",
    "smith-shoulder-press": "Smith-Schulterdrücken",
    "smith-squat-split": "Smith-Bulgarische-Kniebeuge",
    "pendulum-squat": "Pendel-Kniebeuge",
    "seated-calf-raise": "Sitzendes Wadenheben",
    "machine-lat-raise": "Maschinen-Seitheben",
    "machine-bicep-curl": "Maschinen-Bizepscurl",
    "machine-tricep-ext": "Maschinen-Trizepsstreckung",
    "machine-rear-delt": "Maschinen-Reverse-Fly",
    "standing-calf-raise": "Stehendes Wadenheben",
    "cable-hammer-curl": "Kabel-Hammercurl",
    "cable-chest-press": "Kabel-Brustpresse",
    "straight-arm-pulldown": "Gerader-Arm-Latzug",
    "cable-hip-abduction": "Kabel-Hüftabduktion",
    "cable-shrug": "Kabel-Schulterheben",
    "bayesian-curl": "Bayesian-Curl",
    "cable-front-raise": "Kabel-Frontheben",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Kabel-Crossover",
    "cable-tricep-kickback": "Kabel-Trizeps-Kickback",
    "cable-external-rotation": "Kabel-Außenrotation",
    "cable-internal-rotation": "Kabel-Innenrotation",
    "board-press": "Board Press",
    "box-squat": "Box-Kniebeuge",
    "safety-bar-squat": "Safety-Bar-Kniebeuge",
    "block-pull": "Block Pull",
    "tempo-squat": "Tempo-Kniebeuge",
    "sots-press": "Sots Press",
    "hang-clean": "Hängendes Umsetzen",
    "hang-snatch": "Hängendes Reißen",
    "split-jerk": "Ausfallschritt-Stoß",
    "clean-pull": "Clean Pull",
    "snatch-pull": "Snatch Pull",
    "barbell-drag-curl": "Langhantel-Drag-Curl",
    "reverse-barbell-curl": "Reverse-Langhantelcurl",
    "barbell-spider-curl": "Langhantel-Spider-Curl",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "Kurzhantel Power Clean",
    "dumbbell-swing": "Kurzhantel-Swing",
    "dumbbell-split-squat": "Kurzhantel-Bulgarische-Kniebeuge",
    "dumbbell-incline-fly": "Kurzhantel-Schrägbank-Fly",
    "dumbbell-decline-press": "Kurzhantel-Negativ-Drücken",
    "dumbbell-upright-row": "Kurzhantel-Aufrecht-Rudern",
    "single-arm-db-press": "Einarmiges Kurzhanteldrücken",
    "dumbbell-pullover-incline": "Schrägbank-Kurzhantel-Pullover",
    "dumbbell-kickback": "Kurzhantel-Trizeps-Kickback",
    "dumbbell-rear-lunge": "Kurzhantel-Rückwärts-Ausfallschritt",
    "smith-incline-press": "Smith-Schrägbankdrücken",
    "smith-romanian-dl": "Smith-Rumänisches-Kreuzheben",
    "smith-calf-raise": "Smith-Wadenheben",
    "machine-chest-fly": "Maschinen-Brust-Fly",
    "machine-pullover": "Maschinen-Pullover",
    "machine-back-ext": "Maschinen-Rückenstrecker",
    "machine-ab-crunch": "Maschinen-Bauchpresse",
    "machine-preacher-curl": "Maschinen-Preacher-Curl",
    "v-squat": "V-Squat",
    "sissy-squat-machine": "Sissy-Squat-Maschine",
    "wall-sit": "Wandsitzen",
    "superman": "Superman",
    "bear-crawl": "Bärenkrabbeln",
    "mountain-climber": "Bergsteiger",
    "cossack-squat": "Kosaken-Kniebeuge",
    "decline-push-up": "Negativ-Liegestütz",
    "diamond-push-up": "Diamant-Liegestütz",
    "archer-push-up": "Bogenschützen-Liegestütz",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Menschliche Flagge",
    "wrist-curl": "Handgelenkscurl",
    "reverse-wrist-curl": "Reverse-Handgelenkscurl",
    "farmers-walk": "Farmer's Walk",
    "plate-pinch": "Scheiben-Pinch",
    "behind-back-wrist-curl": "Handgelenkscurl hinter dem Rücken",
    "dead-hang": "Passives Hängen",
    "running-1-mile": "1 Meile (1.6km) Lauf",
    "running-5k": "5-km-Lauf",
    "running-10k": "10-km-Lauf",
    "rowing-500m": "500m Rudern",
    "rowing-2000m": "2000m Rudern",
    "cycling-10k": "10km Radfahren",
    "jump-rope-1min": "Seilspringen (1 Min.)",
    "swimming-100m": "100m Schwimmen",
    "stair-climber-10min": "Treppensteiger (10 Min.)",
    "battle-ropes-1min": "Battle Ropes (1 Min.)",
    "assault-bike-cal-1min": "Assault Bike (1 Min. Kal.)",
    "sled-push-40yd": "Schlittenschieben (40 yd)"
  },
  ja: {
    "bench-press": "ベンチプレス",
    "squat": "スクワット",
    "deadlift": "デッドリフト",
    "shoulder-press": "ショルダープレス",
    "barbell-curl": "バーベルカール",
    "bent-over-row": "ベントオーバーロウ",
    "incline-bench-press": "インクラインベンチプレス",
    "front-squat": "フロントスクワット",
    "romanian-deadlift": "ルーマニアンデッドリフト",
    "hip-thrust": "ヒップスラスト",
    "power-clean": "パワークリーン",
    "close-grip-bench": "ナローグリップベンチプレス",
    "lying-tricep-ext": "ライイングトライセプスエクステンション",
    "barbell-shrug": "バーベルシュラッグ",
    "ez-bar-curl": "EZバーカール",
    "overhead-press": "オーバーヘッドプレス",
    "sumo-deadlift": "スモーデッドリフト",
    "pendlay-row": "ペンドレーロウ",
    "barbell-lunge": "バーベルランジ",
    "deficit-deadlift": "デフィシットデッドリフト",
    "floor-press": "フロアプレス",
    "zercher-squat": "ゼルチャースクワット",
    "snatch": "スナッチ",
    "clean-and-jerk": "クリーン＆ジャーク",
    "good-morning": "グッドモーニング",
    "rack-pull": "ラックプル",
    "push-press": "プッシュプレス",
    "decline-bench-press": "デクラインベンチプレス",
    "t-bar-row": "Tバーロウ",
    "pause-squat": "ポーズスクワット",
    "stiff-leg-deadlift": "スティッフレッグデッドリフト",
    "behind-neck-press": "ビハインドネックプレス",
    "preacher-curl": "プリーチャーカール",
    "skull-crusher": "スカルクラッシャー",
    "pull-ups": "懸垂",
    "push-ups": "腕立て伏せ",
    "dips": "ディップス",
    "chin-ups": "チンアップ",
    "muscle-ups": "マッスルアップ",
    "sit-ups": "シットアップ",
    "pistol-squat": "ピストルスクワット",
    "handstand-push-up": "逆立ち腕立て伏せ",
    "planche": "プランシェ",
    "front-lever": "フロントレバー",
    "hanging-leg-raise": "ハンギングレッグレイズ",
    "burpees": "バーピー",
    "inverted-row": "インバーテッドロウ",
    "dragon-flag": "ドラゴンフラッグ",
    "l-sit": "Lシット",
    "back-lever": "バックレバー",
    "nordic-curl": "ノルディックカール",
    "dumbbell-bench-press": "ダンベルベンチプレス",
    "dumbbell-curl": "ダンベルカール",
    "incline-db-bench": "インクラインダンベルプレス",
    "dumbbell-shoulder-press": "ダンベルショルダープレス",
    "dumbbell-lateral-raise": "ダンベルサイドレイズ",
    "dumbbell-row": "ダンベルロウ",
    "hammer-curl": "ハンマーカール",
    "goblet-squat": "ゴブレットスクワット",
    "dumbbell-fly": "ダンベルフライ",
    "dumbbell-pullover": "ダンベルプルオーバー",
    "dumbbell-lunge": "ダンベルランジ",
    "dumbbell-shrug": "ダンベルシュラッグ",
    "concentration-curl": "コンセントレーションカール",
    "dumbbell-tricep-ext": "ダンベルトライセプスエクステンション",
    "dumbbell-reverse-fly": "ダンベルリバースフライ",
    "arnold-press": "アーノルドプレス",
    "dumbbell-front-raise": "ダンベルフロントレイズ",
    "dumbbell-romanian-dl": "ダンベルルーマニアンデッドリフト",
    "dumbbell-step-up": "ダンベルステップアップ",
    "dumbbell-skull-crusher": "ダンベルスカルクラッシャー",
    "incline-dumbbell-curl": "インクラインダンベルカール",
    "dumbbell-calf-raise": "ダンベルカーフレイズ",
    "sled-leg-press": "レッグプレス",
    "leg-extension": "レッグエクステンション",
    "chest-press": "チェストプレス",
    "hack-squat": "ハックスクワット",
    "seated-leg-curl": "シーテッドレッグカール",
    "machine-calf-raise": "マシンカーフレイズ",
    "smith-machine-squat": "スミスマシンスクワット",
    "machine-shoulder-press": "マシンショルダープレス",
    "pec-deck": "ペックデック",
    "leg-press-horizontal": "水平レッグプレス",
    "lying-leg-curl": "ライイングレッグカール",
    "machine-row": "マシンロウ",
    "hip-abduction": "ヒップアブダクション",
    "hip-adduction": "ヒップアダクション",
    "assisted-pull-up": "アシスト懸垂",
    "smith-bench-press": "スミスベンチプレス",
    "reverse-hyper": "リバースハイパー",
    "glute-ham-raise": "グルートハムレイズ",
    "belt-squat": "ベルトスクワット",
    "lat-pulldown": "ラットプルダウン",
    "tricep-pushdown": "トライセプスプッシュダウン",
    "seated-cable-row": "シーテッドケーブルロウ",
    "cable-fly": "ケーブルフライ",
    "face-pull": "フェイスプル",
    "cable-curl": "ケーブルカール",
    "cable-lateral-raise": "ケーブルサイドレイズ",
    "cable-kickback": "ケーブルキックバック",
    "cable-crunch": "ケーブルクランチ",
    "cable-woodchop": "ケーブルウッドチョップ",
    "cable-pull-through": "ケーブルプルスルー",
    "cable-overhead-ext": "ケーブルオーバーヘッドエクステンション",
    "cable-upright-row": "ケーブルアップライトロウ",
    "cable-reverse-fly": "ケーブルリバースフライ",
    "cable-pullover": "ケーブルプルオーバー",
    "barbell-upright-row": "バーベルアップライトロウ",
    "landmine-press": "ランドマインプレス",
    "landmine-row": "ランドマインロウ",
    "barbell-hack-squat": "バーベルハックスクワット",
    "jefferson-squat": "ジェファーソンスクワット",
    "barbell-hip-thrust": "バーベルグルートブリッジ",
    "z-press": "Zプレス",
    "spoto-press": "スポトプレス",
    "pin-squat": "ピンスクワット",
    "snatch-grip-deadlift": "スナッチグリップデッドリフト",
    "trap-bar-deadlift": "トラップバーデッドリフト",
    "barbell-calf-raise": "バーベルカーフレイズ",
    "barbell-pullover": "バーベルプルオーバー",
    "viking-press": "バイキングプレス",
    "larsen-press": "ラーセンプレス",
    "single-leg-squat": "片脚スクワット",
    "ring-dips": "リングディップス",
    "ring-muscle-up": "リングマッスルアップ",
    "toes-to-bar": "トゥズトゥバー",
    "russian-twist": "ロシアンツイスト",
    "pike-push-up": "パイク腕立て伏せ",
    "ab-wheel-rollout": "アブローラー",
    "plank": "プランク",
    "box-jump": "ボックスジャンプ",
    "glute-bridge": "グルートブリッジ",
    "dumbbell-snatch": "ダンベルスナッチ",
    "dumbbell-clean": "ダンベルクリーン",
    "dumbbell-thruster": "ダンベルスラスター",
    "dumbbell-floor-press": "ダンベルフロアプレス",
    "dumbbell-hip-thrust": "ダンベルヒップスラスト",
    "renegade-row": "レネゲードロウ",
    "dumbbell-clean-press": "ダンベルクリーン＆プレス",
    "zottman-curl": "ゾットマンカール",
    "spider-curl": "スパイダーカール",
    "dumbbell-wrist-curl": "ダンベルリストカール",
    "leg-press-single": "片脚レッグプレス",
    "smith-shoulder-press": "スミスショルダープレス",
    "smith-squat-split": "スミスブルガリアンスクワット",
    "pendulum-squat": "ペンデュラムスクワット",
    "seated-calf-raise": "シーテッドカーフレイズ",
    "machine-lat-raise": "マシンサイドレイズ",
    "machine-bicep-curl": "マシンバイセプスカール",
    "machine-tricep-ext": "マシントライセプスエクステンション",
    "machine-rear-delt": "マシンリアデルトフライ",
    "standing-calf-raise": "スタンディングカーフレイズマシン",
    "cable-hammer-curl": "ケーブルハンマーカール",
    "cable-chest-press": "ケーブルチェストプレス",
    "straight-arm-pulldown": "ストレートアームプルダウン",
    "cable-hip-abduction": "ケーブルヒップアブダクション",
    "cable-shrug": "ケーブルシュラッグ",
    "bayesian-curl": "ベイジアンカール",
    "cable-front-raise": "ケーブルフロントレイズ",
    "pallof-press": "パロフプレス",
    "cable-crossover": "ケーブルクロスオーバー",
    "cable-tricep-kickback": "ケーブルトライセプスキックバック",
    "cable-external-rotation": "ケーブル外旋",
    "cable-internal-rotation": "ケーブル内旋",
    "board-press": "ボードプレス",
    "box-squat": "ボックススクワット",
    "safety-bar-squat": "セーフティバースクワット",
    "block-pull": "ブロックプル",
    "tempo-squat": "テンポスクワット",
    "sots-press": "ソッツプレス",
    "hang-clean": "ハングクリーン",
    "hang-snatch": "ハングスナッチ",
    "split-jerk": "スプリットジャーク",
    "clean-pull": "クリーンプル",
    "snatch-pull": "スナッチプル",
    "barbell-drag-curl": "バーベルドラッグカール",
    "reverse-barbell-curl": "リバースバーベルカール",
    "barbell-spider-curl": "バーベルスパイダーカール",
    "jm-press": "JMプレス",
    "dumbbell-power-clean": "ダンベルパワークリーン",
    "dumbbell-swing": "ダンベルスイング",
    "dumbbell-split-squat": "ダンベルブルガリアンスクワット",
    "dumbbell-incline-fly": "ダンベルインクラインフライ",
    "dumbbell-decline-press": "ダンベルデクラインプレス",
    "dumbbell-upright-row": "ダンベルアップライトロウ",
    "single-arm-db-press": "ワンアームダンベルプレス",
    "dumbbell-pullover-incline": "インクラインダンベルプルオーバー",
    "dumbbell-kickback": "ダンベルトライセプスキックバック",
    "dumbbell-rear-lunge": "ダンベルリバースランジ",
    "smith-incline-press": "スミスインクラインプレス",
    "smith-romanian-dl": "スミスルーマニアンデッドリフト",
    "smith-calf-raise": "スミスカーフレイズ",
    "machine-chest-fly": "マシンチェストフライ",
    "machine-pullover": "マシンプルオーバー",
    "machine-back-ext": "マシンバックエクステンション",
    "machine-ab-crunch": "マシンアブクランチ",
    "machine-preacher-curl": "マシンプリーチャーカール",
    "v-squat": "Vスクワット",
    "sissy-squat-machine": "シシースクワットマシン",
    "wall-sit": "ウォールシット",
    "superman": "スーパーマン",
    "bear-crawl": "ベアクロール",
    "mountain-climber": "マウンテンクライマー",
    "cossack-squat": "コサックスクワット",
    "decline-push-up": "デクライン腕立て伏せ",
    "diamond-push-up": "ダイヤモンド腕立て伏せ",
    "archer-push-up": "アーチャー腕立て伏せ",
    "skin-the-cat": "スキン・ザ・キャット",
    "human-flag": "ヒューマンフラッグ",
    "wrist-curl": "リストカール",
    "reverse-wrist-curl": "リバースリストカール",
    "farmers-walk": "ファーマーズウォーク",
    "plate-pinch": "プレートピンチ",
    "behind-back-wrist-curl": "ビハインドバックリストカール",
    "dead-hang": "デッドハング",
    "running-1-mile": "1マイル (1.6km) 走",
    "running-5k": "5km走",
    "running-10k": "10km走",
    "rowing-500m": "500mローイング",
    "rowing-2000m": "2000mローイング",
    "cycling-10k": "10kmサイクリング",
    "jump-rope-1min": "縄跳び（1分）",
    "swimming-100m": "100m水泳",
    "stair-climber-10min": "ステアクライマー（10分）",
    "battle-ropes-1min": "バトルロープ（1分）",
    "assault-bike-cal-1min": "アサルトバイク（1分カロリー）",
    "sled-push-40yd": "スレッドプッシュ（40ヤード）"
  },
  zh: {
    "bench-press": "卧推",
    "squat": "深蹲",
    "deadlift": "硬拉",
    "shoulder-press": "肩推",
    "barbell-curl": "杠铃弯举",
    "bent-over-row": "俯身划船",
    "incline-bench-press": "上斜卧推",
    "front-squat": "前蹲",
    "romanian-deadlift": "罗马尼亚硬拉",
    "hip-thrust": "臀推",
    "power-clean": "高翻",
    "close-grip-bench": "窄握卧推",
    "lying-tricep-ext": "仰卧臂屈伸",
    "barbell-shrug": "杠铃耸肩",
    "ez-bar-curl": "曲杆弯举",
    "overhead-press": "过头推举",
    "sumo-deadlift": "相扑硬拉",
    "pendlay-row": "彭德利划船",
    "barbell-lunge": "杠铃弓步",
    "deficit-deadlift": "赤字硬拉",
    "floor-press": "地板卧推",
    "zercher-squat": "泽奇深蹲",
    "snatch": "抓举",
    "clean-and-jerk": "挺举",
    "good-morning": "早安式",
    "rack-pull": "架上硬拉",
    "push-press": "借力推举",
    "decline-bench-press": "下斜卧推",
    "t-bar-row": "T杠划船",
    "pause-squat": "暂停深蹲",
    "stiff-leg-deadlift": "直腿硬拉",
    "behind-neck-press": "颈后推举",
    "preacher-curl": "布道凳弯举",
    "skull-crusher": "碎颅者",
    "pull-ups": "引体向上",
    "push-ups": "俯卧撑",
    "dips": "双杠臂屈伸",
    "chin-ups": "反握引体向上",
    "muscle-ups": "双力臂",
    "sit-ups": "仰卧起坐",
    "pistol-squat": "手枪深蹲",
    "handstand-push-up": "倒立俯卧撑",
    "planche": "俄式挺身",
    "front-lever": "前水平",
    "hanging-leg-raise": "悬垂举腿",
    "burpees": "波比跳",
    "inverted-row": "反向划船",
    "dragon-flag": "龙旗",
    "l-sit": "L型支撑",
    "back-lever": "后水平",
    "nordic-curl": "北欧弯举",
    "dumbbell-bench-press": "哑铃卧推",
    "dumbbell-curl": "哑铃弯举",
    "incline-db-bench": "上斜哑铃卧推",
    "dumbbell-shoulder-press": "哑铃肩推",
    "dumbbell-lateral-raise": "哑铃侧平举",
    "dumbbell-row": "哑铃划船",
    "hammer-curl": "锤式弯举",
    "goblet-squat": "高脚杯深蹲",
    "dumbbell-fly": "哑铃飞鸟",
    "dumbbell-pullover": "哑铃仰卧上拉",
    "dumbbell-lunge": "哑铃弓步",
    "dumbbell-shrug": "哑铃耸肩",
    "concentration-curl": "集中弯举",
    "dumbbell-tricep-ext": "哑铃臂屈伸",
    "dumbbell-reverse-fly": "哑铃反向飞鸟",
    "arnold-press": "阿诺德推举",
    "dumbbell-front-raise": "哑铃前平举",
    "dumbbell-romanian-dl": "哑铃罗马尼亚硬拉",
    "dumbbell-step-up": "哑铃登台阶",
    "dumbbell-skull-crusher": "哑铃碎颅者",
    "incline-dumbbell-curl": "上斜哑铃弯举",
    "dumbbell-calf-raise": "哑铃提踵",
    "sled-leg-press": "腿举",
    "leg-extension": "腿屈伸",
    "chest-press": "器械推胸",
    "hack-squat": "哈克深蹲",
    "seated-leg-curl": "坐姿腿弯举",
    "machine-calf-raise": "器械提踵",
    "smith-machine-squat": "史密斯深蹲",
    "machine-shoulder-press": "器械肩推",
    "pec-deck": "蝴蝶机夹胸",
    "leg-press-horizontal": "水平腿举",
    "lying-leg-curl": "俯卧腿弯举",
    "machine-row": "器械划船",
    "hip-abduction": "髋外展",
    "hip-adduction": "髋内收",
    "assisted-pull-up": "辅助引体向上",
    "smith-bench-press": "史密斯卧推",
    "reverse-hyper": "反向山羊挺身",
    "glute-ham-raise": "臀腿举",
    "belt-squat": "腰带深蹲",
    "lat-pulldown": "高位下拉",
    "tricep-pushdown": "三头肌下压",
    "seated-cable-row": "坐姿绳索划船",
    "cable-fly": "绳索飞鸟",
    "face-pull": "面拉",
    "cable-curl": "绳索弯举",
    "cable-lateral-raise": "绳索侧平举",
    "cable-kickback": "绳索后踢",
    "cable-crunch": "绳索卷腹",
    "cable-woodchop": "绳索伐木",
    "cable-pull-through": "绳索直腿拉",
    "cable-overhead-ext": "绳索过头臂屈伸",
    "cable-upright-row": "绳索直立划船",
    "cable-reverse-fly": "绳索反向飞鸟",
    "cable-pullover": "绳索仰卧上拉",
    "barbell-upright-row": "杠铃直立划船",
    "landmine-press": "地雷推举",
    "landmine-row": "地雷划船",
    "barbell-hack-squat": "杠铃哈克深蹲",
    "jefferson-squat": "杰弗森深蹲",
    "barbell-hip-thrust": "杠铃臀桥",
    "z-press": "Z推举",
    "spoto-press": "斯波托卧推",
    "pin-squat": "针式深蹲",
    "snatch-grip-deadlift": "抓举握硬拉",
    "trap-bar-deadlift": "六角杆硬拉",
    "barbell-calf-raise": "杠铃提踵",
    "barbell-pullover": "杠铃仰卧上拉",
    "viking-press": "维京推举",
    "larsen-press": "拉森卧推",
    "single-leg-squat": "单腿深蹲",
    "ring-dips": "吊环臂屈伸",
    "ring-muscle-up": "吊环双力臂",
    "toes-to-bar": "脚趾触杆",
    "russian-twist": "俄式转体",
    "pike-push-up": "鱼跃俯卧撑",
    "ab-wheel-rollout": "健腹轮",
    "plank": "平板支撑",
    "box-jump": "跳箱",
    "glute-bridge": "臀桥",
    "dumbbell-snatch": "哑铃抓举",
    "dumbbell-clean": "哑铃翻铃",
    "dumbbell-thruster": "哑铃推举蹲",
    "dumbbell-floor-press": "哑铃地板卧推",
    "dumbbell-hip-thrust": "哑铃臀推",
    "renegade-row": "叛逆划船",
    "dumbbell-clean-press": "哑铃翻铃推举",
    "zottman-curl": "佐特曼弯举",
    "spider-curl": "蜘蛛弯举",
    "dumbbell-wrist-curl": "哑铃腕弯举",
    "leg-press-single": "单腿腿举",
    "smith-shoulder-press": "史密斯肩推",
    "smith-squat-split": "史密斯保加利亚深蹲",
    "pendulum-squat": "摆锤深蹲",
    "seated-calf-raise": "坐姿提踵",
    "machine-lat-raise": "器械侧平举",
    "machine-bicep-curl": "器械弯举",
    "machine-tricep-ext": "器械臂屈伸",
    "machine-rear-delt": "器械反向飞鸟",
    "standing-calf-raise": "站姿提踵器",
    "cable-hammer-curl": "绳索锤式弯举",
    "cable-chest-press": "绳索推胸",
    "straight-arm-pulldown": "直臂下压",
    "cable-hip-abduction": "绳索髋外展",
    "cable-shrug": "绳索耸肩",
    "bayesian-curl": "贝叶斯弯举",
    "cable-front-raise": "绳索前平举",
    "pallof-press": "帕洛夫推",
    "cable-crossover": "绳索夹胸",
    "cable-tricep-kickback": "绳索三头肌后踢",
    "cable-external-rotation": "绳索外旋",
    "cable-internal-rotation": "绳索内旋",
    "board-press": "板上卧推",
    "box-squat": "箱式深蹲",
    "safety-bar-squat": "安全杆深蹲",
    "block-pull": "垫高硬拉",
    "tempo-squat": "节奏深蹲",
    "sots-press": "索茨推举",
    "hang-clean": "悬垂翻铃",
    "hang-snatch": "悬垂抓举",
    "split-jerk": "分腿挺举",
    "clean-pull": "翻铃拉",
    "snatch-pull": "抓举拉",
    "barbell-drag-curl": "杠铃拖曳弯举",
    "reverse-barbell-curl": "反握杠铃弯举",
    "barbell-spider-curl": "杠铃蜘蛛弯举",
    "jm-press": "JM推举",
    "dumbbell-power-clean": "哑铃高翻",
    "dumbbell-swing": "哑铃摆荡",
    "dumbbell-split-squat": "哑铃保加利亚深蹲",
    "dumbbell-incline-fly": "哑铃上斜飞鸟",
    "dumbbell-decline-press": "哑铃下斜卧推",
    "dumbbell-upright-row": "哑铃直立划船",
    "single-arm-db-press": "单臂哑铃推举",
    "dumbbell-pullover-incline": "上斜哑铃仰卧上拉",
    "dumbbell-kickback": "哑铃三头肌后踢",
    "dumbbell-rear-lunge": "哑铃反向弓步",
    "smith-incline-press": "史密斯上斜卧推",
    "smith-romanian-dl": "史密斯罗马尼亚硬拉",
    "smith-calf-raise": "史密斯提踵",
    "machine-chest-fly": "器械飞鸟",
    "machine-pullover": "器械仰卧上拉",
    "machine-back-ext": "器械背部伸展",
    "machine-ab-crunch": "器械卷腹",
    "machine-preacher-curl": "器械布道凳弯举",
    "v-squat": "V型深蹲",
    "sissy-squat-machine": "锡西深蹲机",
    "wall-sit": "靠墙静蹲",
    "superman": "超人式",
    "bear-crawl": "熊爬",
    "mountain-climber": "登山者",
    "cossack-squat": "哥萨克深蹲",
    "decline-push-up": "下斜俯卧撑",
    "diamond-push-up": "钻石俯卧撑",
    "archer-push-up": "弓箭手俯卧撑",
    "skin-the-cat": "翻身上杠",
    "human-flag": "人体旗帜",
    "wrist-curl": "腕弯举",
    "reverse-wrist-curl": "反握腕弯举",
    "farmers-walk": "农夫行走",
    "plate-pinch": "捏盘",
    "behind-back-wrist-curl": "背后腕弯举",
    "dead-hang": "悬挂",
    "running-1-mile": "1英里 (1.6km) 跑",
    "running-5k": "5公里跑",
    "running-10k": "10公里跑",
    "rowing-500m": "500米划船",
    "rowing-2000m": "2000米划船",
    "cycling-10k": "10公里骑行",
    "jump-rope-1min": "跳绳（1分钟）",
    "swimming-100m": "100米游泳",
    "stair-climber-10min": "登梯机（10分钟）",
    "battle-ropes-1min": "战绳（1分钟）",
    "assault-bike-cal-1min": "突击单车（1分钟卡路里）",
    "sled-push-40yd": "推雪橇（40码）"
  },
  pt: {
    "bench-press": "Supino Reto",
    "squat": "Agachamento",
    "deadlift": "Levantamento Terra",
    "shoulder-press": "Desenvolvimento de Ombros",
    "barbell-curl": "Rosca Direta com Barra",
    "bent-over-row": "Remada Curvada",
    "incline-bench-press": "Supino Inclinado",
    "front-squat": "Agachamento Frontal",
    "romanian-deadlift": "Levantamento Terra Romeno",
    "hip-thrust": "Elevação de Quadril",
    "power-clean": "Arranque em Potência",
    "close-grip-bench": "Supino Pegada Fechada",
    "lying-tricep-ext": "Tríceps Testa Deitado",
    "barbell-shrug": "Encolhimento com Barra",
    "ez-bar-curl": "Rosca com Barra W",
    "overhead-press": "Desenvolvimento Militar",
    "sumo-deadlift": "Levantamento Terra Sumo",
    "pendlay-row": "Remada Pendlay",
    "barbell-lunge": "Avanço com Barra",
    "deficit-deadlift": "Levantamento Terra com Déficit",
    "floor-press": "Supino no Chão",
    "zercher-squat": "Agachamento Zercher",
    "snatch": "Arranque",
    "clean-and-jerk": "Arremesso",
    "good-morning": "Bom Dia",
    "rack-pull": "Puxada no Rack",
    "push-press": "Push Press",
    "decline-bench-press": "Supino Declinado",
    "t-bar-row": "Remada Cavalinho",
    "pause-squat": "Agachamento com Pausa",
    "stiff-leg-deadlift": "Stiff",
    "behind-neck-press": "Desenvolvimento Atrás da Nuca",
    "preacher-curl": "Rosca Scott",
    "skull-crusher": "Tríceps Testa",
    "pull-ups": "Barra Fixa",
    "push-ups": "Flexão de Braço",
    "dips": "Paralelas",
    "chin-ups": "Barra Supinada",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Abdominal",
    "pistol-squat": "Agachamento Pistol",
    "handstand-push-up": "Flexão Parada de Mão",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Elevação de Pernas na Barra",
    "burpees": "Burpees",
    "inverted-row": "Remada Invertida",
    "dragon-flag": "Bandeira do Dragão",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Rosca Nórdica",
    "dumbbell-bench-press": "Supino com Halteres",
    "dumbbell-curl": "Rosca com Halter",
    "incline-db-bench": "Supino Inclinado com Halteres",
    "dumbbell-shoulder-press": "Desenvolvimento com Halter",
    "dumbbell-lateral-raise": "Elevação Lateral com Halter",
    "dumbbell-row": "Remada com Halter",
    "hammer-curl": "Rosca Martelo",
    "goblet-squat": "Agachamento Goblet",
    "dumbbell-fly": "Crucifixo com Halter",
    "dumbbell-pullover": "Pullover com Halter",
    "dumbbell-lunge": "Avanço com Halter",
    "dumbbell-shrug": "Encolhimento com Halter",
    "concentration-curl": "Rosca Concentrada",
    "dumbbell-tricep-ext": "Extensão de Tríceps com Halter",
    "dumbbell-reverse-fly": "Crucifixo Inverso com Halter",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "Elevação Frontal com Halter",
    "dumbbell-romanian-dl": "Stiff com Halter",
    "dumbbell-step-up": "Step Up com Halter",
    "dumbbell-skull-crusher": "Tríceps Testa com Halter",
    "incline-dumbbell-curl": "Rosca Inclinada com Halter",
    "dumbbell-calf-raise": "Panturrilha com Halter",
    "sled-leg-press": "Leg Press",
    "leg-extension": "Cadeira Extensora",
    "chest-press": "Supino na Máquina",
    "hack-squat": "Hack Squat",
    "seated-leg-curl": "Mesa Flexora Sentado",
    "machine-calf-raise": "Panturrilha na Máquina",
    "smith-machine-squat": "Agachamento no Smith",
    "machine-shoulder-press": "Desenvolvimento na Máquina",
    "pec-deck": "Peck Deck",
    "leg-press-horizontal": "Leg Press Horizontal",
    "lying-leg-curl": "Mesa Flexora Deitado",
    "machine-row": "Remada na Máquina",
    "hip-abduction": "Abdução de Quadril",
    "hip-adduction": "Adução de Quadril",
    "assisted-pull-up": "Barra Assistida",
    "smith-bench-press": "Supino no Smith",
    "reverse-hyper": "Hiperextensão Reversa",
    "glute-ham-raise": "Glúteo-Femoral",
    "belt-squat": "Agachamento com Cinto",
    "lat-pulldown": "Puxada Alta",
    "tricep-pushdown": "Tríceps na Polia",
    "seated-cable-row": "Remada Sentada no Cabo",
    "cable-fly": "Crucifixo no Cabo",
    "face-pull": "Face Pull",
    "cable-curl": "Rosca no Cabo",
    "cable-lateral-raise": "Elevação Lateral no Cabo",
    "cable-kickback": "Kickback no Cabo",
    "cable-crunch": "Abdominal no Cabo",
    "cable-woodchop": "Lenhador no Cabo",
    "cable-pull-through": "Pull Through no Cabo",
    "cable-overhead-ext": "Extensão sobre a Cabeça no Cabo",
    "cable-upright-row": "Remada Alta no Cabo",
    "cable-reverse-fly": "Crucifixo Inverso no Cabo",
    "cable-pullover": "Pullover no Cabo",
    "barbell-upright-row": "Remada Alta com Barra",
    "landmine-press": "Landmine Press",
    "landmine-row": "Remada Landmine",
    "barbell-hack-squat": "Hack Squat com Barra",
    "jefferson-squat": "Agachamento Jefferson",
    "barbell-hip-thrust": "Ponte de Glúteos com Barra",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Agachamento no Pino",
    "snatch-grip-deadlift": "Terra Pegada de Arranque",
    "trap-bar-deadlift": "Terra com Barra Hexagonal",
    "barbell-calf-raise": "Panturrilha com Barra",
    "barbell-pullover": "Pullover com Barra",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Agachamento Unilateral",
    "ring-dips": "Paralelas nas Argolas",
    "ring-muscle-up": "Muscle Up nas Argolas",
    "toes-to-bar": "Pés na Barra",
    "russian-twist": "Giro Russo",
    "pike-push-up": "Flexão Pike",
    "ab-wheel-rollout": "Roda Abdominal",
    "plank": "Prancha",
    "box-jump": "Salto na Caixa",
    "glute-bridge": "Ponte de Glúteos",
    "dumbbell-snatch": "Arranque com Halter",
    "dumbbell-clean": "Clean com Halter",
    "dumbbell-thruster": "Thruster com Halter",
    "dumbbell-floor-press": "Supino no Chão com Halter",
    "dumbbell-hip-thrust": "Elevação de Quadril com Halter",
    "renegade-row": "Remada Renegada",
    "dumbbell-clean-press": "Clean & Press com Halter",
    "zottman-curl": "Rosca Zottman",
    "spider-curl": "Rosca Aranha",
    "dumbbell-wrist-curl": "Rosca de Punho com Halter",
    "leg-press-single": "Leg Press Unilateral",
    "smith-shoulder-press": "Desenvolvimento Smith",
    "smith-squat-split": "Agachamento Búlgaro Smith",
    "pendulum-squat": "Agachamento Pêndulo",
    "seated-calf-raise": "Panturrilha Sentado",
    "machine-lat-raise": "Elevação Lateral na Máquina",
    "machine-bicep-curl": "Rosca na Máquina",
    "machine-tricep-ext": "Extensão de Tríceps na Máquina",
    "machine-rear-delt": "Deltóide Posterior na Máquina",
    "standing-calf-raise": "Panturrilha em Pé",
    "cable-hammer-curl": "Rosca Martelo no Cabo",
    "cable-chest-press": "Supino no Cabo",
    "straight-arm-pulldown": "Puxada com Braços Retos",
    "cable-hip-abduction": "Abdução de Quadril no Cabo",
    "cable-shrug": "Encolhimento no Cabo",
    "bayesian-curl": "Rosca Bayesiana",
    "cable-front-raise": "Elevação Frontal no Cabo",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Crossover",
    "cable-tricep-kickback": "Kickback de Tríceps no Cabo",
    "cable-external-rotation": "Rotação Externa no Cabo",
    "cable-internal-rotation": "Rotação Interna no Cabo",
    "board-press": "Board Press",
    "box-squat": "Agachamento na Caixa",
    "safety-bar-squat": "Agachamento com Barra de Segurança",
    "block-pull": "Puxada no Bloco",
    "tempo-squat": "Agachamento com Tempo",
    "sots-press": "Sots Press",
    "hang-clean": "Clean Suspenso",
    "hang-snatch": "Arranque Suspenso",
    "split-jerk": "Arremesso em Split",
    "clean-pull": "Puxada de Clean",
    "snatch-pull": "Puxada de Arranque",
    "barbell-drag-curl": "Rosca de Arrasto com Barra",
    "reverse-barbell-curl": "Rosca Inversa com Barra",
    "barbell-spider-curl": "Rosca Aranha com Barra",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "Power Clean com Halter",
    "dumbbell-swing": "Swing com Halter",
    "dumbbell-split-squat": "Agachamento Búlgaro com Halter",
    "dumbbell-incline-fly": "Crucifixo Inclinado com Halter",
    "dumbbell-decline-press": "Supino Declinado com Halter",
    "dumbbell-upright-row": "Remada Alta com Halter",
    "single-arm-db-press": "Desenvolvimento Unilateral com Halter",
    "dumbbell-pullover-incline": "Pullover Inclinado com Halter",
    "dumbbell-kickback": "Kickback de Tríceps com Halter",
    "dumbbell-rear-lunge": "Avanço Reverso com Halter",
    "smith-incline-press": "Supino Inclinado Smith",
    "smith-romanian-dl": "Stiff no Smith",
    "smith-calf-raise": "Panturrilha no Smith",
    "machine-chest-fly": "Crucifixo na Máquina",
    "machine-pullover": "Pullover na Máquina",
    "machine-back-ext": "Extensão de Costas na Máquina",
    "machine-ab-crunch": "Abdominal na Máquina",
    "machine-preacher-curl": "Rosca Scott na Máquina",
    "v-squat": "V Squat",
    "sissy-squat-machine": "Sissy Squat na Máquina",
    "wall-sit": "Cadeirinha na Parede",
    "superman": "Superman",
    "bear-crawl": "Caminhada do Urso",
    "mountain-climber": "Escaladores",
    "cossack-squat": "Agachamento Cossaco",
    "decline-push-up": "Flexão Declinada",
    "diamond-push-up": "Flexão Diamante",
    "archer-push-up": "Flexão Arqueiro",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Bandeira Humana",
    "wrist-curl": "Rosca de Punho",
    "reverse-wrist-curl": "Rosca de Punho Inversa",
    "farmers-walk": "Caminhada do Fazendeiro",
    "plate-pinch": "Pinça de Anilha",
    "behind-back-wrist-curl": "Rosca de Punho Atrás das Costas",
    "dead-hang": "Pendurada Passiva",
    "running-1-mile": "Corrida 1 Milha (1.6km)",
    "running-5k": "Corrida 5K",
    "running-10k": "Corrida 10K",
    "rowing-500m": "Remo 500m",
    "rowing-2000m": "Remo 2000m",
    "cycling-10k": "Ciclismo 10K",
    "jump-rope-1min": "Pular Corda (1 min)",
    "swimming-100m": "Natação 100m",
    "stair-climber-10min": "Escada (10 min)",
    "battle-ropes-1min": "Cordas de Batalha (1 min)",
    "assault-bike-cal-1min": "Assault Bike (1 min cal)",
    "sled-push-40yd": "Empurrar Trenó (40 yd)"
  },
  ru: {
    "bench-press": "Жим лёжа",
    "squat": "Приседание",
    "deadlift": "Становая тяга",
    "shoulder-press": "Жим стоя",
    "barbell-curl": "Подъём штанги на бицепс",
    "bent-over-row": "Тяга штанги в наклоне",
    "incline-bench-press": "Жим на наклонной скамье",
    "front-squat": "Фронтальное приседание",
    "romanian-deadlift": "Румынская тяга",
    "hip-thrust": "Ягодичный мост со штангой",
    "power-clean": "Силовой подъём на грудь",
    "close-grip-bench": "Жим узким хватом",
    "lying-tricep-ext": "Французский жим лёжа",
    "barbell-shrug": "Шраги со штангой",
    "ez-bar-curl": "Подъём EZ-грифа",
    "overhead-press": "Жим над головой",
    "sumo-deadlift": "Становая тяга сумо",
    "pendlay-row": "Тяга Пендли",
    "barbell-lunge": "Выпады со штангой",
    "deficit-deadlift": "Становая тяга с дефицитом",
    "floor-press": "Жим с пола",
    "zercher-squat": "Приседание Зерчера",
    "snatch": "Рывок",
    "clean-and-jerk": "Толчок",
    "good-morning": "Гуд-морнинг",
    "rack-pull": "Тяга с упоров",
    "push-press": "Жимовой швунг",
    "decline-bench-press": "Жим на обратно-наклонной скамье",
    "t-bar-row": "Тяга Т-грифа",
    "pause-squat": "Приседание с паузой",
    "stiff-leg-deadlift": "Мёртвая тяга",
    "behind-neck-press": "Жим из-за головы",
    "preacher-curl": "Подъём на скамье Скотта",
    "skull-crusher": "Французский жим",
    "pull-ups": "Подтягивания",
    "push-ups": "Отжимания",
    "dips": "Отжимания на брусьях",
    "chin-ups": "Подтягивания обратным хватом",
    "muscle-ups": "Выход силой",
    "sit-ups": "Скручивания",
    "pistol-squat": "Приседание-пистолет",
    "handstand-push-up": "Отжимание в стойке на руках",
    "planche": "Планш",
    "front-lever": "Передний вис",
    "hanging-leg-raise": "Подъём ног в висе",
    "burpees": "Бёрпи",
    "inverted-row": "Обратная тяга",
    "dragon-flag": "Флаг дракона",
    "l-sit": "Уголок",
    "back-lever": "Задний вис",
    "nordic-curl": "Скандинавский сгибатель",
    "dumbbell-bench-press": "Жим гантелей лёжа",
    "dumbbell-curl": "Подъём гантелей на бицепс",
    "incline-db-bench": "Жим гантелей на наклонной",
    "dumbbell-shoulder-press": "Жим гантелей сидя",
    "dumbbell-lateral-raise": "Разведение гантелей",
    "dumbbell-row": "Тяга гантели в наклоне",
    "hammer-curl": "Молотковый подъём",
    "goblet-squat": "Кубковое приседание",
    "dumbbell-fly": "Разводки с гантелями",
    "dumbbell-pullover": "Пуловер с гантелью",
    "dumbbell-lunge": "Выпады с гантелями",
    "dumbbell-shrug": "Шраги с гантелями",
    "concentration-curl": "Концентрированный подъём",
    "dumbbell-tricep-ext": "Разгибание с гантелью на трицепс",
    "dumbbell-reverse-fly": "Обратные разводки с гантелями",
    "arnold-press": "Жим Арнольда",
    "dumbbell-front-raise": "Подъём гантелей перед собой",
    "dumbbell-romanian-dl": "Румынская тяга с гантелями",
    "dumbbell-step-up": "Шагания с гантелями",
    "dumbbell-skull-crusher": "Французский жим с гантелью",
    "incline-dumbbell-curl": "Подъём гантелей на наклонной",
    "dumbbell-calf-raise": "Подъём на носки с гантелями",
    "sled-leg-press": "Жим ногами",
    "leg-extension": "Разгибание ног",
    "chest-press": "Жим от груди в тренажёре",
    "hack-squat": "Гакк-приседание",
    "seated-leg-curl": "Сгибание ног сидя",
    "machine-calf-raise": "Подъём на носки в тренажёре",
    "smith-machine-squat": "Приседание в Смите",
    "machine-shoulder-press": "Жим в тренажёре",
    "pec-deck": "Бабочка",
    "leg-press-horizontal": "Горизонтальный жим ногами",
    "lying-leg-curl": "Сгибание ног лёжа",
    "machine-row": "Тяга в тренажёре",
    "hip-abduction": "Разведение ног",
    "hip-adduction": "Сведение ног",
    "assisted-pull-up": "Подтягивания с помощью",
    "smith-bench-press": "Жим лёжа в Смите",
    "reverse-hyper": "Обратная гиперэкстензия",
    "glute-ham-raise": "Ягодично-бедренный подъём",
    "belt-squat": "Приседание с поясом",
    "lat-pulldown": "Тяга верхнего блока",
    "tricep-pushdown": "Жим на трицепс на блоке",
    "seated-cable-row": "Тяга нижнего блока",
    "cable-fly": "Сведение рук на блоке",
    "face-pull": "Тяга к лицу",
    "cable-curl": "Подъём на бицепс на блоке",
    "cable-lateral-raise": "Разведение на блоке",
    "cable-kickback": "Кикбэк на блоке",
    "cable-crunch": "Скручивания на блоке",
    "cable-woodchop": "Дровосек на блоке",
    "cable-pull-through": "Протяжка через ноги",
    "cable-overhead-ext": "Разгибание над головой на блоке",
    "cable-upright-row": "Тяга к подбородку на блоке",
    "cable-reverse-fly": "Обратные разводки на блоке",
    "cable-pullover": "Пуловер на блоке",
    "barbell-upright-row": "Тяга штанги к подбородку",
    "landmine-press": "Жим лэндмайн",
    "landmine-row": "Тяга лэндмайн",
    "barbell-hack-squat": "Гакк-приседание со штангой",
    "jefferson-squat": "Приседание Джефферсона",
    "barbell-hip-thrust": "Ягодичный мост со штангой",
    "z-press": "Z-жим",
    "spoto-press": "Жим Споуто",
    "pin-squat": "Приседание с упоров",
    "snatch-grip-deadlift": "Тяга рывковым хватом",
    "trap-bar-deadlift": "Тяга трэп-грифом",
    "barbell-calf-raise": "Подъём на носки со штангой",
    "barbell-pullover": "Пуловер со штангой",
    "viking-press": "Жим Викинг",
    "larsen-press": "Жим Ларсена",
    "single-leg-squat": "Приседание на одной ноге",
    "ring-dips": "Отжимания на кольцах",
    "ring-muscle-up": "Выход силой на кольцах",
    "toes-to-bar": "Носки к перекладине",
    "russian-twist": "Русский поворот",
    "pike-push-up": "Отжимание «уголок»",
    "ab-wheel-rollout": "Ролик для пресса",
    "plank": "Планка",
    "box-jump": "Прыжок на тумбу",
    "glute-bridge": "Ягодичный мост",
    "dumbbell-snatch": "Рывок гантели",
    "dumbbell-clean": "Подъём гантели на грудь",
    "dumbbell-thruster": "Трастер с гантелями",
    "dumbbell-floor-press": "Жим гантелей с пола",
    "dumbbell-hip-thrust": "Ягодичный мост с гантелью",
    "renegade-row": "Тяга ренегата",
    "dumbbell-clean-press": "Подъём и жим гантели",
    "zottman-curl": "Подъём Зоттмана",
    "spider-curl": "Паучий подъём",
    "dumbbell-wrist-curl": "Сгибание кисти с гантелью",
    "leg-press-single": "Жим одной ногой",
    "smith-shoulder-press": "Жим сидя в Смите",
    "smith-squat-split": "Болгарские приседания в Смите",
    "pendulum-squat": "Маятниковое приседание",
    "seated-calf-raise": "Подъём на носки сидя",
    "machine-lat-raise": "Разведение в тренажёре",
    "machine-bicep-curl": "Бицепс в тренажёре",
    "machine-tricep-ext": "Трицепс в тренажёре",
    "machine-rear-delt": "Задняя дельта в тренажёре",
    "standing-calf-raise": "Подъём на носки стоя",
    "cable-hammer-curl": "Молотковый подъём на блоке",
    "cable-chest-press": "Жим от груди на блоке",
    "straight-arm-pulldown": "Тяга прямыми руками",
    "cable-hip-abduction": "Разведение ног на блоке",
    "cable-shrug": "Шраги на блоке",
    "bayesian-curl": "Байесовский подъём",
    "cable-front-raise": "Подъём перед собой на блоке",
    "pallof-press": "Жим Паллофа",
    "cable-crossover": "Кроссовер",
    "cable-tricep-kickback": "Кикбэк на трицепс на блоке",
    "cable-external-rotation": "Наружная ротация на блоке",
    "cable-internal-rotation": "Внутренняя ротация на блоке",
    "board-press": "Жим с доски",
    "box-squat": "Приседание на ящик",
    "safety-bar-squat": "Приседание с безопасным грифом",
    "block-pull": "Тяга с блоков",
    "tempo-squat": "Темповое приседание",
    "sots-press": "Жим Сотса",
    "hang-clean": "Подъём на грудь с виса",
    "hang-snatch": "Рывок с виса",
    "split-jerk": "Швунг в ножницы",
    "clean-pull": "Тяга толчковая",
    "snatch-pull": "Тяга рывковая",
    "barbell-drag-curl": "Подъём штанги вдоль тела",
    "reverse-barbell-curl": "Обратный подъём штанги",
    "barbell-spider-curl": "Паучий подъём со штангой",
    "jm-press": "JM-жим",
    "dumbbell-power-clean": "Силовой подъём гантели",
    "dumbbell-swing": "Мах гантелью",
    "dumbbell-split-squat": "Болгарские приседания с гантелями",
    "dumbbell-incline-fly": "Разводки на наклонной с гантелями",
    "dumbbell-decline-press": "Жим гантелей на обратно-наклонной",
    "dumbbell-upright-row": "Тяга гантелей к подбородку",
    "single-arm-db-press": "Жим одной рукой",
    "dumbbell-pullover-incline": "Пуловер на наклонной с гантелью",
    "dumbbell-kickback": "Кикбэк с гантелью",
    "dumbbell-rear-lunge": "Обратные выпады с гантелями",
    "smith-incline-press": "Жим на наклонной в Смите",
    "smith-romanian-dl": "Румынская тяга в Смите",
    "smith-calf-raise": "Подъём на носки в Смите",
    "machine-chest-fly": "Сведение в тренажёре",
    "machine-pullover": "Пуловер в тренажёре",
    "machine-back-ext": "Разгибание спины в тренажёре",
    "machine-ab-crunch": "Скручивание в тренажёре",
    "machine-preacher-curl": "Скамья Скотта в тренажёре",
    "v-squat": "V-приседание",
    "sissy-squat-machine": "Сисси-приседание в тренажёре",
    "wall-sit": "Стульчик у стены",
    "superman": "Супермен",
    "bear-crawl": "Медвежья ходьба",
    "mountain-climber": "Скалолаз",
    "cossack-squat": "Казачье приседание",
    "decline-push-up": "Отжимание с ног",
    "diamond-push-up": "Алмазное отжимание",
    "archer-push-up": "Отжимание лучника",
    "skin-the-cat": "Переворот на перекладине",
    "human-flag": "Человеческий флаг",
    "wrist-curl": "Сгибание запястья",
    "reverse-wrist-curl": "Обратное сгибание запястья",
    "farmers-walk": "Прогулка фермера",
    "plate-pinch": "Щипковый хват",
    "behind-back-wrist-curl": "Сгибание запястья за спиной",
    "dead-hang": "Пассивный вис",
    "running-1-mile": "Бег 1 миля (1.6km)",
    "running-5k": "Бег 5 км",
    "running-10k": "Бег 10 км",
    "rowing-500m": "Гребля 500 м",
    "rowing-2000m": "Гребля 2000 м",
    "cycling-10k": "Велосипед 10 км",
    "jump-rope-1min": "Скакалка (1 мин)",
    "swimming-100m": "Плавание 100 м",
    "stair-climber-10min": "Степпер (10 мин)",
    "battle-ropes-1min": "Канаты (1 мин)",
    "assault-bike-cal-1min": "Штурмовой велосипед (1 мин кал)",
    "sled-push-40yd": "Толкание саней (40 ярдов)"
  },
  ar: {
    "bench-press": "ضغط البنش",
    "squat": "سكوات",
    "deadlift": "ديدليفت",
    "shoulder-press": "ضغط الكتف",
    "barbell-curl": "كيرل بالبار",
    "bent-over-row": "تجديف منحني",
    "incline-bench-press": "ضغط بنش مائل",
    "front-squat": "سكوات أمامي",
    "romanian-deadlift": "ديدليفت روماني",
    "hip-thrust": "هيب ثرست",
    "power-clean": "باور كلين",
    "close-grip-bench": "ضغط بنش قبضة ضيقة",
    "lying-tricep-ext": "تمديد تراي أثناء الاستلقاء",
    "barbell-shrug": "شرج بالبار",
    "ez-bar-curl": "كيرل بالبار المنحني",
    "overhead-press": "ضغط فوق الرأس",
    "sumo-deadlift": "ديدليفت سومو",
    "pendlay-row": "تجديف بندلاي",
    "barbell-lunge": "لانج بالبار",
    "deficit-deadlift": "ديدليفت من عجز",
    "floor-press": "ضغط من الأرض",
    "zercher-squat": "سكوات زيرشر",
    "snatch": "خطف",
    "clean-and-jerk": "نتر وضغط",
    "good-morning": "جود مورنينج",
    "rack-pull": "سحب من الرف",
    "push-press": "بوش بريس",
    "decline-bench-press": "ضغط بنش منحدر",
    "t-bar-row": "تجديف تي بار",
    "pause-squat": "سكوات مع توقف",
    "stiff-leg-deadlift": "ديدليفت ساق مستقيمة",
    "behind-neck-press": "ضغط خلف الرقبة",
    "preacher-curl": "بريتشر كيرل",
    "skull-crusher": "سكل كراشر",
    "pull-ups": "عقلة",
    "push-ups": "ضغط",
    "dips": "ديبس",
    "chin-ups": "عقلة بقبضة سفلية",
    "muscle-ups": "ماسل أب",
    "sit-ups": "سيت أبس",
    "pistol-squat": "سكوات بساق واحدة",
    "handstand-push-up": "ضغط وقوف على اليدين",
    "planche": "بلانش",
    "front-lever": "فرونت ليفر",
    "hanging-leg-raise": "رفع الساق معلقاً",
    "burpees": "بيربي",
    "inverted-row": "تجديف معكوس",
    "dragon-flag": "علم التنين",
    "l-sit": "إل-سيت",
    "back-lever": "باك ليفر",
    "nordic-curl": "كيرل نورديك",
    "dumbbell-bench-press": "ضغط بنش بالدمبل",
    "dumbbell-curl": "كيرل بالدمبل",
    "incline-db-bench": "ضغط مائل بالدمبل",
    "dumbbell-shoulder-press": "ضغط كتف بالدمبل",
    "dumbbell-lateral-raise": "رفع جانبي بالدمبل",
    "dumbbell-row": "تجديف بالدمبل",
    "hammer-curl": "هامر كيرل",
    "goblet-squat": "سكوات غوبلت",
    "dumbbell-fly": "فلاي بالدمبل",
    "dumbbell-pullover": "بولوفر بالدمبل",
    "dumbbell-lunge": "لانج بالدمبل",
    "dumbbell-shrug": "شرج بالدمبل",
    "concentration-curl": "كيرل مركّز",
    "dumbbell-tricep-ext": "تمديد تراي بالدمبل",
    "dumbbell-reverse-fly": "فلاي معكوس بالدمبل",
    "arnold-press": "ضغط أرنولد",
    "dumbbell-front-raise": "رفع أمامي بالدمبل",
    "dumbbell-romanian-dl": "ديدليفت روماني بالدمبل",
    "dumbbell-step-up": "ستيب أب بالدمبل",
    "dumbbell-skull-crusher": "سكل كراشر بالدمبل",
    "incline-dumbbell-curl": "كيرل مائل بالدمبل",
    "dumbbell-calf-raise": "رفع الساق بالدمبل",
    "sled-leg-press": "ضغط الساق",
    "leg-extension": "تمديد الساق",
    "chest-press": "ضغط الصدر بالآلة",
    "hack-squat": "هاك سكوات",
    "seated-leg-curl": "ثني الساق جالساً",
    "machine-calf-raise": "رفع الساق بالآلة",
    "smith-machine-squat": "سكوات سميث",
    "machine-shoulder-press": "ضغط كتف بالآلة",
    "pec-deck": "بيك ديك",
    "leg-press-horizontal": "ضغط ساق أفقي",
    "lying-leg-curl": "ثني الساق مستلقياً",
    "machine-row": "تجديف بالآلة",
    "hip-abduction": "تبعيد الورك",
    "hip-adduction": "تقريب الورك",
    "assisted-pull-up": "عقلة بمساعدة",
    "smith-bench-press": "ضغط بنش سميث",
    "reverse-hyper": "هايبر معكوس",
    "glute-ham-raise": "رفع المؤخرة",
    "belt-squat": "سكوات بالحزام",
    "lat-pulldown": "سحب علوي",
    "tricep-pushdown": "ضغط التراي",
    "seated-cable-row": "تجديف بالكيبل جالساً",
    "cable-fly": "فلاي بالكيبل",
    "face-pull": "فيس بول",
    "cable-curl": "كيرل بالكيبل",
    "cable-lateral-raise": "رفع جانبي بالكيبل",
    "cable-kickback": "كيك باك بالكيبل",
    "cable-crunch": "كرانش بالكيبل",
    "cable-woodchop": "حطّاب بالكيبل",
    "cable-pull-through": "سحب من بين الساقين بالكيبل",
    "cable-overhead-ext": "تمديد فوق الرأس بالكيبل",
    "cable-upright-row": "تجديف عمودي بالكيبل",
    "cable-reverse-fly": "فلاي معكوس بالكيبل",
    "cable-pullover": "بولوفر بالكيبل",
    "barbell-upright-row": "تجديف عمودي بالبار",
    "landmine-press": "لاندماين بريس",
    "landmine-row": "تجديف لاندماين",
    "barbell-hack-squat": "هاك سكوات بالبار",
    "jefferson-squat": "سكوات جيفرسون",
    "barbell-hip-thrust": "جسر الأرداف بالبار",
    "z-press": "زد بريس",
    "spoto-press": "سبوتو بريس",
    "pin-squat": "سكوات من الدبابيس",
    "snatch-grip-deadlift": "ديدليفت قبضة الخطف",
    "trap-bar-deadlift": "ديدليفت بالبار السداسي",
    "barbell-calf-raise": "رفع الساق بالبار",
    "barbell-pullover": "بولوفر بالبار",
    "viking-press": "فايكينغ بريس",
    "larsen-press": "لارسن بريس",
    "single-leg-squat": "سكوات بساق واحدة",
    "ring-dips": "ديبس على الحلقات",
    "ring-muscle-up": "ماسل أب على الحلقات",
    "toes-to-bar": "أصابع إلى البار",
    "russian-twist": "لف روسي",
    "pike-push-up": "ضغط بايك",
    "ab-wheel-rollout": "عجلة البطن",
    "plank": "بلانك",
    "box-jump": "قفز على الصندوق",
    "glute-bridge": "جسر الأرداف",
    "dumbbell-snatch": "خطف بالدمبل",
    "dumbbell-clean": "كلين بالدمبل",
    "dumbbell-thruster": "ثرستر بالدمبل",
    "dumbbell-floor-press": "ضغط من الأرض بالدمبل",
    "dumbbell-hip-thrust": "هيب ثرست بالدمبل",
    "renegade-row": "تجديف رينيغيد",
    "dumbbell-clean-press": "كلين و ضغط بالدمبل",
    "zottman-curl": "زوتمان كيرل",
    "spider-curl": "سبايدر كيرل",
    "dumbbell-wrist-curl": "ثني المعصم بالدمبل",
    "leg-press-single": "ضغط ساق بساق واحدة",
    "smith-shoulder-press": "ضغط كتف سميث",
    "smith-squat-split": "سكوات بلغاري سميث",
    "pendulum-squat": "سكوات بندول",
    "seated-calf-raise": "رفع الساق جالساً",
    "machine-lat-raise": "رفع جانبي بالآلة",
    "machine-bicep-curl": "كيرل بالآلة",
    "machine-tricep-ext": "تمديد تراي بالآلة",
    "machine-rear-delt": "دلتويد خلفي بالآلة",
    "standing-calf-raise": "رفع الساق واقفاً",
    "cable-hammer-curl": "هامر كيرل بالكيبل",
    "cable-chest-press": "ضغط صدر بالكيبل",
    "straight-arm-pulldown": "سحب بذراع مستقيم",
    "cable-hip-abduction": "تبعيد الورك بالكيبل",
    "cable-shrug": "شرج بالكيبل",
    "bayesian-curl": "بايسيان كيرل",
    "cable-front-raise": "رفع أمامي بالكيبل",
    "pallof-press": "بالوف بريس",
    "cable-crossover": "كروس أوفر",
    "cable-tricep-kickback": "كيك باك تراي بالكيبل",
    "cable-external-rotation": "دوران خارجي بالكيبل",
    "cable-internal-rotation": "دوران داخلي بالكيبل",
    "board-press": "ضغط بلوح",
    "box-squat": "سكوات على الصندوق",
    "safety-bar-squat": "سكوات بار الأمان",
    "block-pull": "سحب من البلوكات",
    "tempo-squat": "سكوات بإيقاع",
    "sots-press": "سوتس بريس",
    "hang-clean": "كلين معلق",
    "hang-snatch": "خطف معلق",
    "split-jerk": "جيرك سبليت",
    "clean-pull": "سحب كلين",
    "snatch-pull": "سحب خطف",
    "barbell-drag-curl": "كيرل سحب بالبار",
    "reverse-barbell-curl": "كيرل معكوس بالبار",
    "barbell-spider-curl": "سبايدر كيرل بالبار",
    "jm-press": "جي أم بريس",
    "dumbbell-power-clean": "باور كلين بالدمبل",
    "dumbbell-swing": "سوينج بالدمبل",
    "dumbbell-split-squat": "سبليت سكوات بالدمبل",
    "dumbbell-incline-fly": "فلاي مائل بالدمبل",
    "dumbbell-decline-press": "ضغط منحدر بالدمبل",
    "dumbbell-upright-row": "تجديف عمودي بالدمبل",
    "single-arm-db-press": "ضغط بيد واحدة بالدمبل",
    "dumbbell-pullover-incline": "بولوفر مائل بالدمبل",
    "dumbbell-kickback": "كيك باك تراي بالدمبل",
    "dumbbell-rear-lunge": "لانج خلفي بالدمبل",
    "smith-incline-press": "ضغط مائل سميث",
    "smith-romanian-dl": "ديدليفت روماني سميث",
    "smith-calf-raise": "رفع ساق سميث",
    "machine-chest-fly": "فلاي صدر بالآلة",
    "machine-pullover": "بولوفر بالآلة",
    "machine-back-ext": "تمديد الظهر بالآلة",
    "machine-ab-crunch": "كرانش بالآلة",
    "machine-preacher-curl": "بريتشر كيرل بالآلة",
    "v-squat": "في سكوات",
    "sissy-squat-machine": "سيسي سكوات بالآلة",
    "wall-sit": "جلوس على الحائط",
    "superman": "سوبرمان",
    "bear-crawl": "زحف الدب",
    "mountain-climber": "متسلق الجبال",
    "cossack-squat": "سكوات قوزاقي",
    "decline-push-up": "ضغط منحدر",
    "diamond-push-up": "ضغط ماسي",
    "archer-push-up": "ضغط الرامي",
    "skin-the-cat": "سكين ذا كات",
    "human-flag": "العلم البشري",
    "wrist-curl": "ثني المعصم",
    "reverse-wrist-curl": "ثني المعصم المعكوس",
    "farmers-walk": "مشية المزارع",
    "plate-pinch": "قرص القبضة",
    "behind-back-wrist-curl": "ثني المعصم خلف الظهر",
    "dead-hang": "تعلق سلبي",
    "running-1-mile": "جري 1 ميل (1.6 كم)",
    "running-5k": "جري 5 كم",
    "running-10k": "جري 10 كم",
    "rowing-500m": "تجديف 500 م",
    "rowing-2000m": "تجديف 2000 م",
    "cycling-10k": "دراجة 10 كم",
    "jump-rope-1min": "قفز الحبل (1 دقيقة)",
    "swimming-100m": "سباحة 100 م",
    "stair-climber-10min": "تسلق الدرج (10 دقائق)",
    "battle-ropes-1min": "حبال المعركة (1 دقيقة)",
    "assault-bike-cal-1min": "دراجة هجومية (1 دقيقة سعرات)",
    "sled-push-40yd": "دفع الزلاجة (40 ياردة)"
  },
  hi: {
    "bench-press": "बेंच प्रेस",
    "squat": "स्क्वॉट",
    "deadlift": "डेडलिफ्ट",
    "shoulder-press": "शोल्डर प्रेस",
    "barbell-curl": "बारबेल कर्ल",
    "bent-over-row": "बेंट ओवर रो",
    "incline-bench-press": "इंक्लाइन बेंच प्रेस",
    "front-squat": "फ्रंट स्क्वॉट",
    "romanian-deadlift": "रोमानियन डेडलिफ्ट",
    "hip-thrust": "हिप थ्रस्ट",
    "power-clean": "पावर क्लीन",
    "close-grip-bench": "क्लोज ग्रिप बेंच प्रेस",
    "lying-tricep-ext": "लाइंग ट्राइसेप्स एक्सटेंशन",
    "barbell-shrug": "बारबेल श्रग",
    "ez-bar-curl": "EZ बार कर्ल",
    "overhead-press": "ओवरहेड प्रेस",
    "sumo-deadlift": "सूमो डेडलिफ्ट",
    "pendlay-row": "पेंडले रो",
    "barbell-lunge": "बारबेल लंज",
    "deficit-deadlift": "डेफिसिट डेडलिफ्ट",
    "floor-press": "फ्लोर प्रेस",
    "zercher-squat": "ज़र्चर स्क्वॉट",
    "snatch": "स्नैच",
    "clean-and-jerk": "क्लीन एंड जर्क",
    "good-morning": "गुड मॉर्निंग",
    "rack-pull": "रैक पुल",
    "push-press": "पुश प्रेस",
    "decline-bench-press": "डिक्लाइन बेंच प्रेस",
    "t-bar-row": "टी-बार रो",
    "pause-squat": "पॉज़ स्क्वॉट",
    "stiff-leg-deadlift": "स्टिफ लेग डेडलिफ्ट",
    "behind-neck-press": "बिहाइंड नेक प्रेस",
    "preacher-curl": "प्रीचर कर्ल",
    "skull-crusher": "स्कल क्रशर",
    "pull-ups": "पुल अप्स",
    "push-ups": "पुश अप्स",
    "dips": "डिप्स",
    "chin-ups": "चिन अप्स",
    "muscle-ups": "मसल अप्स",
    "sit-ups": "सिट अप्स",
    "pistol-squat": "पिस्टल स्क्वॉट",
    "handstand-push-up": "हैंडस्टैंड पुश अप",
    "planche": "प्लांश",
    "front-lever": "फ्रंट लीवर",
    "hanging-leg-raise": "हैंगिंग लेग रेज़",
    "burpees": "बर्पीज़",
    "inverted-row": "इनवर्टेड रो",
    "dragon-flag": "ड्रैगन फ्लैग",
    "l-sit": "एल-सिट",
    "back-lever": "बैक लीवर",
    "nordic-curl": "नॉर्डिक कर्ल",
    "dumbbell-bench-press": "डम्बल बेंच प्रेस",
    "dumbbell-curl": "डम्बल कर्ल",
    "incline-db-bench": "इंक्लाइन डम्बल बेंच प्रेस",
    "dumbbell-shoulder-press": "डम्बल शोल्डर प्रेस",
    "dumbbell-lateral-raise": "डम्बल लेटरल रेज़",
    "dumbbell-row": "डम्बल रो",
    "hammer-curl": "हैमर कर्ल",
    "goblet-squat": "गॉब्लेट स्क्वॉट",
    "dumbbell-fly": "डम्बल फ्लाई",
    "dumbbell-pullover": "डम्बल पुलओवर",
    "dumbbell-lunge": "डम्बल लंज",
    "dumbbell-shrug": "डम्बल श्रग",
    "concentration-curl": "कॉन्संट्रेशन कर्ल",
    "dumbbell-tricep-ext": "डम्बल ट्राइसेप्स एक्सटेंशन",
    "dumbbell-reverse-fly": "डम्बल रिवर्स फ्लाई",
    "arnold-press": "अर्नोल्ड प्रेस",
    "dumbbell-front-raise": "डम्बल फ्रंट रेज़",
    "dumbbell-romanian-dl": "डम्बल रोमानियन डेडलिफ्ट",
    "dumbbell-step-up": "डम्बल स्टेप अप",
    "dumbbell-skull-crusher": "डम्बल स्कल क्रशर",
    "incline-dumbbell-curl": "इंक्लाइन डम्बल कर्ल",
    "dumbbell-calf-raise": "डम्बल काफ रेज़",
    "sled-leg-press": "लेग प्रेस",
    "leg-extension": "लेग एक्सटेंशन",
    "chest-press": "चेस्ट प्रेस मशीन",
    "hack-squat": "हैक स्क्वॉट",
    "seated-leg-curl": "सीटेड लेग कर्ल",
    "machine-calf-raise": "मशीन काफ रेज़",
    "smith-machine-squat": "स्मिथ मशीन स्क्वॉट",
    "machine-shoulder-press": "मशीन शोल्डर प्रेस",
    "pec-deck": "पेक डेक",
    "leg-press-horizontal": "होरिज़ॉन्टल लेग प्रेस",
    "lying-leg-curl": "लाइंग लेग कर्ल",
    "machine-row": "मशीन रो",
    "hip-abduction": "हिप एब्डक्शन",
    "hip-adduction": "हिप एडक्शन",
    "assisted-pull-up": "असिस्टेड पुल अप",
    "smith-bench-press": "स्मिथ बेंच प्रेस",
    "reverse-hyper": "रिवर्स हाइपर",
    "glute-ham-raise": "ग्लूट हैम रेज़",
    "belt-squat": "बेल्ट स्क्वॉट",
    "lat-pulldown": "लैट पुलडाउन",
    "tricep-pushdown": "ट्राइसेप्स पुशडाउन",
    "seated-cable-row": "सीटेड केबल रो",
    "cable-fly": "केबल फ्लाई",
    "face-pull": "फेस पुल",
    "cable-curl": "केबल कर्ल",
    "cable-lateral-raise": "केबल लेटरल रेज़",
    "cable-kickback": "केबल किकबैक",
    "cable-crunch": "केबल क्रंच",
    "cable-woodchop": "केबल वुडचॉप",
    "cable-pull-through": "केबल पुल थ्रू",
    "cable-overhead-ext": "केबल ओवरहेड एक्सटेंशन",
    "cable-upright-row": "केबल अपराइट रो",
    "cable-reverse-fly": "केबल रिवर्स फ्लाई",
    "cable-pullover": "केबल पुलओवर",
    "barbell-upright-row": "बारबेल अपराइट रो",
    "landmine-press": "लैंडमाइन प्रेस",
    "landmine-row": "लैंडमाइन रो",
    "barbell-hack-squat": "बारबेल हैक स्क्वॉट",
    "jefferson-squat": "जेफरसन स्क्वॉट",
    "barbell-hip-thrust": "बारबेल ग्लूट ब्रिज",
    "z-press": "Z प्रेस",
    "spoto-press": "स्पोटो प्रेस",
    "pin-squat": "पिन स्क्वॉट",
    "snatch-grip-deadlift": "स्नैच ग्रिप डेडलिफ्ट",
    "trap-bar-deadlift": "ट्रैप बार डेडलिफ्ट",
    "barbell-calf-raise": "बारबेल काफ रेज़",
    "barbell-pullover": "बारबेल पुलओवर",
    "viking-press": "वाइकिंग प्रेस",
    "larsen-press": "लार्सन प्रेस",
    "single-leg-squat": "सिंगल लेग स्क्वॉट",
    "ring-dips": "रिंग डिप्स",
    "ring-muscle-up": "रिंग मसल अप",
    "toes-to-bar": "टोज़ टू बार",
    "russian-twist": "रशियन ट्विस्ट",
    "pike-push-up": "पाइक पुश अप",
    "ab-wheel-rollout": "एब व्हील रोलआउट",
    "plank": "प्लैंक",
    "box-jump": "बॉक्स जंप",
    "glute-bridge": "ग्लूट ब्रिज",
    "dumbbell-snatch": "डम्बल स्नैच",
    "dumbbell-clean": "डम्बल क्लीन",
    "dumbbell-thruster": "डम्बल थ्रस्टर",
    "dumbbell-floor-press": "डम्बल फ्लोर प्रेस",
    "dumbbell-hip-thrust": "डम्बल हिप थ्रस्ट",
    "renegade-row": "रेनिगेड रो",
    "dumbbell-clean-press": "डम्बल क्लीन एंड प्रेस",
    "zottman-curl": "ज़ोट्मन कर्ल",
    "spider-curl": "स्पाइडर कर्ल",
    "dumbbell-wrist-curl": "डम्बल रिस्ट कर्ल",
    "leg-press-single": "सिंगल लेग प्रेस",
    "smith-shoulder-press": "स्मिथ शोल्डर प्रेस",
    "smith-squat-split": "स्मिथ स्प्लिट स्क्वॉट",
    "pendulum-squat": "पेंडुलम स्क्वॉट",
    "seated-calf-raise": "सीटेड काफ रेज़",
    "machine-lat-raise": "मशीन लेटरल रेज़",
    "machine-bicep-curl": "मशीन बाइसेप्स कर्ल",
    "machine-tricep-ext": "मशीन ट्राइसेप्स एक्सटेंशन",
    "machine-rear-delt": "मशीन रियर डेल्ट फ्लाई",
    "standing-calf-raise": "स्टैंडिंग काफ रेज़ मशीन",
    "cable-hammer-curl": "केबल हैमर कर्ल",
    "cable-chest-press": "केबल चेस्ट प्रेस",
    "straight-arm-pulldown": "स्ट्रेट आर्म पुलडाउन",
    "cable-hip-abduction": "केबल हिप एब्डक्शन",
    "cable-shrug": "केबल श्रग",
    "bayesian-curl": "बेयसियन कर्ल",
    "cable-front-raise": "केबल फ्रंट रेज़",
    "pallof-press": "पैलोफ प्रेस",
    "cable-crossover": "केबल क्रॉसओवर",
    "cable-tricep-kickback": "केबल ट्राइसेप्स किकबैक",
    "cable-external-rotation": "केबल बाह्य घूर्णन",
    "cable-internal-rotation": "केबल आंतरिक घूर्णन",
    "board-press": "बोर्ड प्रेस",
    "box-squat": "बॉक्स स्क्वॉट",
    "safety-bar-squat": "सेफ्टी बार स्क्वॉट",
    "block-pull": "ब्लॉक पुल",
    "tempo-squat": "टेम्पो स्क्वॉट",
    "sots-press": "सॉट्स प्रेस",
    "hang-clean": "हैंग क्लीन",
    "hang-snatch": "हैंग स्नैच",
    "split-jerk": "स्प्लिट जर्क",
    "clean-pull": "क्लीन पुल",
    "snatch-pull": "स्नैच पुल",
    "barbell-drag-curl": "बारबेल ड्रैग कर्ल",
    "reverse-barbell-curl": "रिवर्स बारबेल कर्ल",
    "barbell-spider-curl": "बारबेल स्पाइडर कर्ल",
    "jm-press": "JM प्रेस",
    "dumbbell-power-clean": "डम्बल पावर क्लीन",
    "dumbbell-swing": "डम्बल स्विंग",
    "dumbbell-split-squat": "डम्बल स्प्लिट स्क्वॉट",
    "dumbbell-incline-fly": "डम्बल इंक्लाइन फ्लाई",
    "dumbbell-decline-press": "डम्बल डिक्लाइन प्रेस",
    "dumbbell-upright-row": "डम्बल अपराइट रो",
    "single-arm-db-press": "सिंगल आर्म डम्बल प्रेस",
    "dumbbell-pullover-incline": "इंक्लाइन डम्बल पुलओवर",
    "dumbbell-kickback": "डम्बल ट्राइसेप्स किकबैक",
    "dumbbell-rear-lunge": "डम्बल रिवर्स लंज",
    "smith-incline-press": "स्मिथ इंक्लाइन प्रेस",
    "smith-romanian-dl": "स्मिथ रोमानियन डेडलिफ्ट",
    "smith-calf-raise": "स्मिथ काफ रेज़",
    "machine-chest-fly": "मशीन चेस्ट फ्लाई",
    "machine-pullover": "मशीन पुलओवर",
    "machine-back-ext": "मशीन बैक एक्सटेंशन",
    "machine-ab-crunch": "मशीन एब क्रंच",
    "machine-preacher-curl": "मशीन प्रीचर कर्ल",
    "v-squat": "V स्क्वॉट",
    "sissy-squat-machine": "सिसी स्क्वॉट मशीन",
    "wall-sit": "वॉल सिट",
    "superman": "सुपरमैन",
    "bear-crawl": "बेयर क्रॉल",
    "mountain-climber": "माउंटेन क्लाइमर",
    "cossack-squat": "कोसैक स्क्वॉट",
    "decline-push-up": "डिक्लाइन पुश अप",
    "diamond-push-up": "डायमंड पुश अप",
    "archer-push-up": "आर्चर पुश अप",
    "skin-the-cat": "स्किन द कैट",
    "human-flag": "ह्यूमन फ्लैग",
    "wrist-curl": "रिस्ट कर्ल",
    "reverse-wrist-curl": "रिवर्स रिस्ट कर्ल",
    "farmers-walk": "फार्मर्स वॉक",
    "plate-pinch": "प्लेट पिंच",
    "behind-back-wrist-curl": "बिहाइंड बैक रिस्ट कर्ल",
    "dead-hang": "डेड हैंग",
    "running-1-mile": "1 मील (1.6km) दौड़",
    "running-5k": "5 किमी दौड़",
    "running-10k": "10 किमी दौड़",
    "rowing-500m": "500 मीटर रोइंग",
    "rowing-2000m": "2000 मीटर रोइंग",
    "cycling-10k": "10 किमी साइकिलिंग",
    "jump-rope-1min": "रस्सी कूदना (1 मिनट)",
    "swimming-100m": "100 मीटर तैराकी",
    "stair-climber-10min": "सीढ़ी चढ़ना (10 मिनट)",
    "battle-ropes-1min": "बैटल रोप्स (1 मिनट)",
    "assault-bike-cal-1min": "असॉल्ट बाइक (1 मिनट कैलोरी)",
    "sled-push-40yd": "स्लेड पुश (40 यार्ड)"
  },
  it: {
    "bench-press": "Panca Piana",
    "squat": "Squat",
    "deadlift": "Stacco da Terra",
    "shoulder-press": "Pressa Spalle",
    "barbell-curl": "Curl con Bilanciere",
    "bent-over-row": "Rematore con Bilanciere",
    "incline-bench-press": "Panca Inclinata",
    "front-squat": "Squat Frontale",
    "romanian-deadlift": "Stacco Rumeno",
    "hip-thrust": "Hip Thrust",
    "power-clean": "Girata in Potenza",
    "close-grip-bench": "Panca Presa Stretta",
    "lying-tricep-ext": "French Press Sdraiato",
    "barbell-shrug": "Scrollate con Bilanciere",
    "ez-bar-curl": "Curl con Bilanciere EZ",
    "overhead-press": "Military Press",
    "sumo-deadlift": "Stacco Sumo",
    "pendlay-row": "Rematore Pendlay",
    "barbell-lunge": "Affondo con Bilanciere",
    "deficit-deadlift": "Stacco in Deficit",
    "floor-press": "Floor Press",
    "zercher-squat": "Squat Zercher",
    "snatch": "Strappo",
    "clean-and-jerk": "Slancio",
    "good-morning": "Good Morning",
    "rack-pull": "Rack Pull",
    "push-press": "Push Press",
    "decline-bench-press": "Panca Declinata",
    "t-bar-row": "Rematore T-Bar",
    "pause-squat": "Squat con Pausa",
    "stiff-leg-deadlift": "Stacco Gambe Tese",
    "behind-neck-press": "Lento Dietro",
    "preacher-curl": "Curl alla Panca Scott",
    "skull-crusher": "Skull Crusher",
    "pull-ups": "Trazioni alla Sbarra",
    "push-ups": "Piegamenti",
    "dips": "Dip alle Parallele",
    "chin-ups": "Trazioni Supine",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Sit Up",
    "pistol-squat": "Pistol Squat",
    "handstand-push-up": "Piegamento in Verticale",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Alzata Gambe alla Sbarra",
    "burpees": "Burpees",
    "inverted-row": "Rematore Inverso",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Curl Nordico",
    "dumbbell-bench-press": "Panca con Manubri",
    "dumbbell-curl": "Curl con Manubrio",
    "incline-db-bench": "Panca Inclinata con Manubri",
    "dumbbell-shoulder-press": "Pressa Spalle con Manubrio",
    "dumbbell-lateral-raise": "Alzate Laterali con Manubrio",
    "dumbbell-row": "Rematore con Manubrio",
    "hammer-curl": "Curl a Martello",
    "goblet-squat": "Goblet Squat",
    "dumbbell-fly": "Croci con Manubri",
    "dumbbell-pullover": "Pullover con Manubrio",
    "dumbbell-lunge": "Affondo con Manubri",
    "dumbbell-shrug": "Scrollate con Manubri",
    "concentration-curl": "Curl Concentrato",
    "dumbbell-tricep-ext": "Estensione Tricipiti con Manubrio",
    "dumbbell-reverse-fly": "Croci Inverse con Manubrio",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "Alzate Frontali con Manubrio",
    "dumbbell-romanian-dl": "Stacco Rumeno con Manubri",
    "dumbbell-step-up": "Step Up con Manubri",
    "dumbbell-skull-crusher": "Skull Crusher con Manubrio",
    "incline-dumbbell-curl": "Curl Inclinato con Manubrio",
    "dumbbell-calf-raise": "Calf Raise con Manubrio",
    "sled-leg-press": "Leg Press",
    "leg-extension": "Leg Extension",
    "chest-press": "Chest Press",
    "hack-squat": "Hack Squat",
    "seated-leg-curl": "Leg Curl Seduto",
    "machine-calf-raise": "Calf Raise alla Macchina",
    "smith-machine-squat": "Squat al Multipower",
    "machine-shoulder-press": "Pressa Spalle alla Macchina",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Leg Press Orizzontale",
    "lying-leg-curl": "Leg Curl Sdraiato",
    "machine-row": "Rematore alla Macchina",
    "hip-abduction": "Abduzione Anca",
    "hip-adduction": "Adduzione Anca",
    "assisted-pull-up": "Trazioni Assistite",
    "smith-bench-press": "Panca al Multipower",
    "reverse-hyper": "Iperestensione Inversa",
    "glute-ham-raise": "Glute Ham Raise",
    "belt-squat": "Squat con Cintura",
    "lat-pulldown": "Lat Machine",
    "tricep-pushdown": "Push Down Tricipiti",
    "seated-cable-row": "Rematore ai Cavi Seduto",
    "cable-fly": "Croci ai Cavi",
    "face-pull": "Face Pull",
    "cable-curl": "Curl ai Cavi",
    "cable-lateral-raise": "Alzate Laterali ai Cavi",
    "cable-kickback": "Kickback ai Cavi",
    "cable-crunch": "Crunch ai Cavi",
    "cable-woodchop": "Woodchop ai Cavi",
    "cable-pull-through": "Pull Through ai Cavi",
    "cable-overhead-ext": "Estensione Sopra la Testa ai Cavi",
    "cable-upright-row": "Tirate al Mento ai Cavi",
    "cable-reverse-fly": "Croci Inverse ai Cavi",
    "cable-pullover": "Pullover ai Cavi",
    "barbell-upright-row": "Tirate al Mento con Bilanciere",
    "landmine-press": "Landmine Press",
    "landmine-row": "Rematore Landmine",
    "barbell-hack-squat": "Hack Squat con Bilanciere",
    "jefferson-squat": "Squat Jefferson",
    "barbell-hip-thrust": "Ponte Glutei con Bilanciere",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Pin Squat",
    "snatch-grip-deadlift": "Stacco Presa Strappo",
    "trap-bar-deadlift": "Stacco con Trap Bar",
    "barbell-calf-raise": "Calf Raise con Bilanciere",
    "barbell-pullover": "Pullover con Bilanciere",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Squat su Una Gamba",
    "ring-dips": "Dip agli Anelli",
    "ring-muscle-up": "Muscle Up agli Anelli",
    "toes-to-bar": "Piedi alla Sbarra",
    "russian-twist": "Torsione Russa",
    "pike-push-up": "Piegamento Pike",
    "ab-wheel-rollout": "Ruota Addominale",
    "plank": "Plank",
    "box-jump": "Salto sulla Cassa",
    "glute-bridge": "Ponte Glutei",
    "dumbbell-snatch": "Strappo con Manubrio",
    "dumbbell-clean": "Girata con Manubrio",
    "dumbbell-thruster": "Thruster con Manubrio",
    "dumbbell-floor-press": "Floor Press con Manubri",
    "dumbbell-hip-thrust": "Hip Thrust con Manubrio",
    "renegade-row": "Rematore Renegade",
    "dumbbell-clean-press": "Girata e Slancio con Manubrio",
    "zottman-curl": "Curl Zottman",
    "spider-curl": "Curl Spider",
    "dumbbell-wrist-curl": "Curl Polso con Manubrio",
    "leg-press-single": "Leg Press Unilaterale",
    "smith-shoulder-press": "Pressa Spalle al Multipower",
    "smith-squat-split": "Squat Bulgaro al Multipower",
    "pendulum-squat": "Squat a Pendolo",
    "seated-calf-raise": "Calf Raise Seduto",
    "machine-lat-raise": "Alzate Laterali alla Macchina",
    "machine-bicep-curl": "Curl Bicipiti alla Macchina",
    "machine-tricep-ext": "Estensione Tricipiti alla Macchina",
    "machine-rear-delt": "Deltoide Posteriore alla Macchina",
    "standing-calf-raise": "Calf Raise in Piedi",
    "cable-hammer-curl": "Curl a Martello ai Cavi",
    "cable-chest-press": "Chest Press ai Cavi",
    "straight-arm-pulldown": "Pulldown a Braccia Tese",
    "cable-hip-abduction": "Abduzione Anca ai Cavi",
    "cable-shrug": "Scrollate ai Cavi",
    "bayesian-curl": "Curl Bayesiano",
    "cable-front-raise": "Alzate Frontali ai Cavi",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Croci ai Cavi Incrociate",
    "cable-tricep-kickback": "Kickback Tricipiti ai Cavi",
    "cable-external-rotation": "Rotazione Esterna ai Cavi",
    "cable-internal-rotation": "Rotazione Interna ai Cavi",
    "board-press": "Board Press",
    "box-squat": "Box Squat",
    "safety-bar-squat": "Squat con Barra di Sicurezza",
    "block-pull": "Stacco dai Blocchi",
    "tempo-squat": "Squat Tempo",
    "sots-press": "Sots Press",
    "hang-clean": "Girata dal Ginocchio",
    "hang-snatch": "Strappo dal Ginocchio",
    "split-jerk": "Slancio in Divaricata",
    "clean-pull": "Tirata di Girata",
    "snatch-pull": "Tirata di Strappo",
    "barbell-drag-curl": "Curl Drag con Bilanciere",
    "reverse-barbell-curl": "Curl Inverso con Bilanciere",
    "barbell-spider-curl": "Curl Spider con Bilanciere",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "Power Clean con Manubrio",
    "dumbbell-swing": "Swing con Manubrio",
    "dumbbell-split-squat": "Squat Bulgaro con Manubri",
    "dumbbell-incline-fly": "Croci Inclinate con Manubri",
    "dumbbell-decline-press": "Panca Declinata con Manubri",
    "dumbbell-upright-row": "Tirate al Mento con Manubri",
    "single-arm-db-press": "Pressa Unilaterale con Manubrio",
    "dumbbell-pullover-incline": "Pullover Inclinato con Manubrio",
    "dumbbell-kickback": "Kickback Tricipiti con Manubrio",
    "dumbbell-rear-lunge": "Affondo Inverso con Manubri",
    "smith-incline-press": "Panca Inclinata al Multipower",
    "smith-romanian-dl": "Stacco Rumeno al Multipower",
    "smith-calf-raise": "Calf Raise al Multipower",
    "machine-chest-fly": "Croci Petto alla Macchina",
    "machine-pullover": "Pullover alla Macchina",
    "machine-back-ext": "Estensione Schiena alla Macchina",
    "machine-ab-crunch": "Crunch alla Macchina",
    "machine-preacher-curl": "Curl Scott alla Macchina",
    "v-squat": "V Squat",
    "sissy-squat-machine": "Sissy Squat alla Macchina",
    "wall-sit": "Sedia al Muro",
    "superman": "Superman",
    "bear-crawl": "Camminata dell'Orso",
    "mountain-climber": "Mountain Climber",
    "cossack-squat": "Squat Cosacco",
    "decline-push-up": "Piegamento Declinato",
    "diamond-push-up": "Piegamento Diamante",
    "archer-push-up": "Piegamento Arciere",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Bandiera Umana",
    "wrist-curl": "Curl del Polso",
    "reverse-wrist-curl": "Curl Polso Inverso",
    "farmers-walk": "Camminata del Contadino",
    "plate-pinch": "Pinza del Disco",
    "behind-back-wrist-curl": "Curl Polso Dietro la Schiena",
    "dead-hang": "Sospensione Passiva",
    "running-1-mile": "Corsa 1 Miglio (1.6km)",
    "running-5k": "Corsa 5K",
    "running-10k": "Corsa 10K",
    "rowing-500m": "Vogata 500m",
    "rowing-2000m": "Vogata 2000m",
    "cycling-10k": "Ciclismo 10K",
    "jump-rope-1min": "Corda per Saltare (1 min)",
    "swimming-100m": "Nuoto 100m",
    "stair-climber-10min": "Scalini (10 min)",
    "battle-ropes-1min": "Funi da Battaglia (1 min)",
    "assault-bike-cal-1min": "Assault Bike (1 min cal)",
    "sled-push-40yd": "Spinta della Slitta (40 yd)"
  },
  vi: {
    "bench-press": "Đẩy ngực ngang",
    "squat": "Gánh tạ",
    "deadlift": "Kéo xà ngang",
    "shoulder-press": "Đẩy vai",
    "barbell-curl": "Cuốn tạ đòn",
    "bent-over-row": "Chèo tạ cúi người",
    "incline-bench-press": "Đẩy ngực nghiêng",
    "front-squat": "Gánh trước",
    "romanian-deadlift": "Kéo xà Romania",
    "hip-thrust": "Đẩy hông",
    "power-clean": "Đẩy sức mạnh",
    "close-grip-bench": "Đẩy ngực tay hẹp",
    "lying-tricep-ext": "Duỗi tay sau nằm",
    "barbell-shrug": "Nhún vai tạ đòn",
    "ez-bar-curl": "Cuốn tạ EZ",
    "overhead-press": "Đẩy qua đầu",
    "sumo-deadlift": "Kéo xà sumo",
    "pendlay-row": "Chèo Pendlay",
    "barbell-lunge": "Bước dài tạ đòn",
    "deficit-deadlift": "Kéo xà từ bệ thấp",
    "floor-press": "Đẩy từ sàn",
    "zercher-squat": "Gánh Zercher",
    "snatch": "Giật",
    "clean-and-jerk": "Đẩy đẩy",
    "good-morning": "Good Morning",
    "rack-pull": "Kéo từ giá",
    "push-press": "Đẩy hỗ trợ",
    "decline-bench-press": "Đẩy ngực dốc",
    "t-bar-row": "Chèo T-bar",
    "pause-squat": "Gánh dừng",
    "stiff-leg-deadlift": "Kéo xà chân thẳng",
    "behind-neck-press": "Đẩy sau gáy",
    "preacher-curl": "Cuốn tay Preacher",
    "skull-crusher": "Skull Crusher",
    "pull-ups": "Hít xà đơn",
    "push-ups": "Chống đẩy",
    "dips": "Dips",
    "chin-ups": "Hít xà ngửa tay",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Gập bụng",
    "pistol-squat": "Gánh một chân",
    "handstand-push-up": "Chống đẩy trồng chuối",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Nâng chân treo",
    "burpees": "Burpees",
    "inverted-row": "Chèo ngược",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Nordic Curl",
    "dumbbell-bench-press": "Đẩy ngực tạ đơn",
    "dumbbell-curl": "Cuốn tạ đơn",
    "incline-db-bench": "Đẩy ngực nghiêng tạ đơn",
    "dumbbell-shoulder-press": "Đẩy vai tạ đơn",
    "dumbbell-lateral-raise": "Nâng tay ngang tạ đơn",
    "dumbbell-row": "Chèo tạ đơn",
    "hammer-curl": "Cuốn tay búa",
    "goblet-squat": "Gánh tạ Goblet",
    "dumbbell-fly": "Bay tạ đơn",
    "dumbbell-pullover": "Kéo tạ đơn qua đầu",
    "dumbbell-lunge": "Bước dài tạ đơn",
    "dumbbell-shrug": "Nhún vai tạ đơn",
    "concentration-curl": "Cuốn tập trung",
    "dumbbell-tricep-ext": "Duỗi tay sau tạ đơn",
    "dumbbell-reverse-fly": "Bay ngược tạ đơn",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "Nâng tay trước tạ đơn",
    "dumbbell-romanian-dl": "Kéo xà Romania tạ đơn",
    "dumbbell-step-up": "Bước lên tạ đơn",
    "dumbbell-skull-crusher": "Skull Crusher tạ đơn",
    "incline-dumbbell-curl": "Cuốn tay nghiêng tạ đơn",
    "dumbbell-calf-raise": "Nâng bắp chân tạ đơn",
    "sled-leg-press": "Đạp chân",
    "leg-extension": "Duỗi chân",
    "chest-press": "Đẩy ngực máy",
    "hack-squat": "Hack Squat",
    "seated-leg-curl": "Co chân ngồi",
    "machine-calf-raise": "Nâng bắp chân máy",
    "smith-machine-squat": "Gánh Smith",
    "machine-shoulder-press": "Đẩy vai máy",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Đạp chân ngang",
    "lying-leg-curl": "Co chân nằm",
    "machine-row": "Chèo máy",
    "hip-abduction": "Dạng hông",
    "hip-adduction": "Khép hông",
    "assisted-pull-up": "Hít xà hỗ trợ",
    "smith-bench-press": "Đẩy ngực Smith",
    "reverse-hyper": "Hyperextension ngược",
    "glute-ham-raise": "Nâng mông-đùi sau",
    "belt-squat": "Gánh dây đai",
    "lat-pulldown": "Kéo xà máy",
    "tricep-pushdown": "Đẩy tay sau xuống",
    "seated-cable-row": "Chèo cáp ngồi",
    "cable-fly": "Bay cáp",
    "face-pull": "Kéo mặt",
    "cable-curl": "Cuốn cáp",
    "cable-lateral-raise": "Nâng ngang cáp",
    "cable-kickback": "Đá sau cáp",
    "cable-crunch": "Gập bụng cáp",
    "cable-woodchop": "Chặt gỗ cáp",
    "cable-pull-through": "Kéo cáp qua chân",
    "cable-overhead-ext": "Duỗi tay trên đầu cáp",
    "cable-upright-row": "Chèo đứng cáp",
    "cable-reverse-fly": "Bay ngược cáp",
    "cable-pullover": "Pullover cáp",
    "barbell-upright-row": "Chèo đứng tạ đòn",
    "landmine-press": "Đẩy Landmine",
    "landmine-row": "Chèo Landmine",
    "barbell-hack-squat": "Hack Squat tạ đòn",
    "jefferson-squat": "Gánh Jefferson",
    "barbell-hip-thrust": "Cầu mông tạ đòn",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Gánh từ chốt",
    "snatch-grip-deadlift": "Kéo xà tay rộng",
    "trap-bar-deadlift": "Kéo xà Trap Bar",
    "barbell-calf-raise": "Nâng bắp chân tạ đòn",
    "barbell-pullover": "Pullover tạ đòn",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Gánh một chân",
    "ring-dips": "Dips vòng",
    "ring-muscle-up": "Muscle Up vòng",
    "toes-to-bar": "Chạm mũi chân lên xà",
    "russian-twist": "Xoay người Nga",
    "pike-push-up": "Chống đẩy Pike",
    "ab-wheel-rollout": "Lăn bánh xe bụng",
    "plank": "Plank",
    "box-jump": "Nhảy hộp",
    "glute-bridge": "Cầu mông",
    "dumbbell-snatch": "Giật tạ đơn",
    "dumbbell-clean": "Clean tạ đơn",
    "dumbbell-thruster": "Thruster tạ đơn",
    "dumbbell-floor-press": "Đẩy từ sàn tạ đơn",
    "dumbbell-hip-thrust": "Đẩy hông tạ đơn",
    "renegade-row": "Chèo Renegade",
    "dumbbell-clean-press": "Clean & Press tạ đơn",
    "zottman-curl": "Zottman Curl",
    "spider-curl": "Spider Curl",
    "dumbbell-wrist-curl": "Cuốn cổ tay tạ đơn",
    "leg-press-single": "Đạp chân một chân",
    "smith-shoulder-press": "Đẩy vai Smith",
    "smith-squat-split": "Gánh Bulgaria Smith",
    "pendulum-squat": "Gánh con lắc",
    "seated-calf-raise": "Nâng bắp chân ngồi",
    "machine-lat-raise": "Nâng ngang máy",
    "machine-bicep-curl": "Cuốn tay trước máy",
    "machine-tricep-ext": "Duỗi tay sau máy",
    "machine-rear-delt": "Vai sau máy",
    "standing-calf-raise": "Nâng bắp chân đứng",
    "cable-hammer-curl": "Cuốn búa cáp",
    "cable-chest-press": "Đẩy ngực cáp",
    "straight-arm-pulldown": "Kéo tay thẳng xuống",
    "cable-hip-abduction": "Dạng hông cáp",
    "cable-shrug": "Nhún vai cáp",
    "bayesian-curl": "Bayesian Curl",
    "cable-front-raise": "Nâng trước cáp",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Cáp chéo",
    "cable-tricep-kickback": "Đá tay sau cáp",
    "cable-external-rotation": "Xoay ngoài cáp",
    "cable-internal-rotation": "Xoay trong cáp",
    "board-press": "Đẩy trên bảng",
    "box-squat": "Gánh hộp",
    "safety-bar-squat": "Gánh thanh an toàn",
    "block-pull": "Kéo từ khối",
    "tempo-squat": "Gánh nhịp",
    "sots-press": "Sots Press",
    "hang-clean": "Clean treo",
    "hang-snatch": "Giật treo",
    "split-jerk": "Đẩy chân chéo",
    "clean-pull": "Kéo Clean",
    "snatch-pull": "Kéo Giật",
    "barbell-drag-curl": "Cuốn kéo tạ đòn",
    "reverse-barbell-curl": "Cuốn ngược tạ đòn",
    "barbell-spider-curl": "Spider Curl tạ đòn",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "Power Clean tạ đơn",
    "dumbbell-swing": "Swing tạ đơn",
    "dumbbell-split-squat": "Gánh Bulgaria tạ đơn",
    "dumbbell-incline-fly": "Bay nghiêng tạ đơn",
    "dumbbell-decline-press": "Đẩy dốc tạ đơn",
    "dumbbell-upright-row": "Chèo đứng tạ đơn",
    "single-arm-db-press": "Đẩy một tay tạ đơn",
    "dumbbell-pullover-incline": "Pullover nghiêng tạ đơn",
    "dumbbell-kickback": "Đá tay sau tạ đơn",
    "dumbbell-rear-lunge": "Bước dài ngược tạ đơn",
    "smith-incline-press": "Đẩy nghiêng Smith",
    "smith-romanian-dl": "Romania Smith",
    "smith-calf-raise": "Nâng bắp chân Smith",
    "machine-chest-fly": "Bay ngực máy",
    "machine-pullover": "Pullover máy",
    "machine-back-ext": "Duỗi lưng máy",
    "machine-ab-crunch": "Gập bụng máy",
    "machine-preacher-curl": "Preacher Curl máy",
    "v-squat": "V Squat",
    "sissy-squat-machine": "Sissy Squat máy",
    "wall-sit": "Ngồi tường",
    "superman": "Superman",
    "bear-crawl": "Bò gấu",
    "mountain-climber": "Leo núi",
    "cossack-squat": "Gánh Cossack",
    "decline-push-up": "Chống đẩy dốc",
    "diamond-push-up": "Chống đẩy kim cương",
    "archer-push-up": "Chống đẩy cung thủ",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Cờ người",
    "wrist-curl": "Cuốn cổ tay",
    "reverse-wrist-curl": "Cuốn cổ tay ngược",
    "farmers-walk": "Đi bộ nông dân",
    "plate-pinch": "Kẹp đĩa",
    "behind-back-wrist-curl": "Cuốn cổ tay sau lưng",
    "dead-hang": "Treo thụ động",
    "running-1-mile": "Chạy 1 dặm (1.6km)",
    "running-5k": "Chạy 5km",
    "running-10k": "Chạy 10km",
    "rowing-500m": "Chèo 500m",
    "rowing-2000m": "Chèo 2000m",
    "cycling-10k": "Đạp xe 10km",
    "jump-rope-1min": "Nhảy dây (1 phút)",
    "swimming-100m": "Bơi 100m",
    "stair-climber-10min": "Leo cầu thang (10 phút)",
    "battle-ropes-1min": "Dây chiến đấu (1 phút)",
    "assault-bike-cal-1min": "Assault Bike (1 phút calo)",
    "sled-push-40yd": "Đẩy xe trượt (40 yd)"
  },
  tl: {
    "bench-press": "Bench Press",
    "squat": "Squat",
    "deadlift": "Deadlift",
    "shoulder-press": "Shoulder Press",
    "barbell-curl": "Barbell Curl",
    "bent-over-row": "Bent Over Row",
    "incline-bench-press": "Incline Bench Press",
    "front-squat": "Front Squat",
    "romanian-deadlift": "Romanian Deadlift",
    "hip-thrust": "Hip Thrust",
    "power-clean": "Power Clean",
    "close-grip-bench": "Close Grip Bench Press",
    "lying-tricep-ext": "Lying Tricep Extension",
    "barbell-shrug": "Barbell Shrug",
    "ez-bar-curl": "EZ Bar Curl",
    "overhead-press": "Overhead Press",
    "sumo-deadlift": "Sumo Deadlift",
    "pendlay-row": "Pendlay Row",
    "barbell-lunge": "Barbell Lunge",
    "deficit-deadlift": "Deficit Deadlift",
    "floor-press": "Floor Press",
    "zercher-squat": "Zercher Squat",
    "snatch": "Snatch",
    "clean-and-jerk": "Clean and Jerk",
    "good-morning": "Good Morning",
    "rack-pull": "Rack Pull",
    "push-press": "Push Press",
    "decline-bench-press": "Decline Bench Press",
    "t-bar-row": "T-Bar Row",
    "pause-squat": "Pause Squat",
    "stiff-leg-deadlift": "Stiff Leg Deadlift",
    "behind-neck-press": "Behind Neck Press",
    "preacher-curl": "Preacher Curl",
    "skull-crusher": "Skull Crusher",
    "pull-ups": "Pull Ups",
    "push-ups": "Push Ups",
    "dips": "Dips",
    "chin-ups": "Chin Ups",
    "muscle-ups": "Muscle Ups",
    "sit-ups": "Sit Ups",
    "pistol-squat": "Pistol Squat",
    "handstand-push-up": "Handstand Push Up",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Hanging Leg Raise",
    "burpees": "Burpees",
    "inverted-row": "Inverted Row",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Nordic Curl",
    "dumbbell-bench-press": "Dumbbell Bench Press",
    "dumbbell-curl": "Dumbbell Curl",
    "incline-db-bench": "Incline DB Bench Press",
    "dumbbell-shoulder-press": "DB Shoulder Press",
    "dumbbell-lateral-raise": "DB Lateral Raise",
    "dumbbell-row": "Dumbbell Row",
    "hammer-curl": "Hammer Curl",
    "goblet-squat": "Goblet Squat",
    "dumbbell-fly": "Dumbbell Fly",
    "dumbbell-pullover": "Dumbbell Pullover",
    "dumbbell-lunge": "Dumbbell Lunge",
    "dumbbell-shrug": "Dumbbell Shrug",
    "concentration-curl": "Concentration Curl",
    "dumbbell-tricep-ext": "DB Tricep Extension",
    "dumbbell-reverse-fly": "DB Reverse Fly",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "DB Front Raise",
    "dumbbell-romanian-dl": "DB Romanian Deadlift",
    "dumbbell-step-up": "DB Step Up",
    "dumbbell-skull-crusher": "DB Skull Crusher",
    "incline-dumbbell-curl": "Incline DB Curl",
    "dumbbell-calf-raise": "DB Calf Raise",
    "sled-leg-press": "Sled Leg Press",
    "leg-extension": "Leg Extension",
    "chest-press": "Chest Press",
    "hack-squat": "Hack Squat",
    "seated-leg-curl": "Seated Leg Curl",
    "machine-calf-raise": "Machine Calf Raise",
    "smith-machine-squat": "Smith Machine Squat",
    "machine-shoulder-press": "Machine Shoulder Press",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Horizontal Leg Press",
    "lying-leg-curl": "Lying Leg Curl",
    "machine-row": "Machine Row",
    "hip-abduction": "Hip Abduction",
    "hip-adduction": "Hip Adduction",
    "assisted-pull-up": "Assisted Pull Up",
    "smith-bench-press": "Smith Bench Press",
    "reverse-hyper": "Reverse Hyper",
    "glute-ham-raise": "Glute Ham Raise",
    "belt-squat": "Belt Squat",
    "lat-pulldown": "Lat Pulldown",
    "tricep-pushdown": "Tricep Pushdown",
    "seated-cable-row": "Seated Cable Row",
    "cable-fly": "Cable Fly",
    "face-pull": "Face Pull",
    "cable-curl": "Cable Curl",
    "cable-lateral-raise": "Cable Lateral Raise",
    "cable-kickback": "Cable Kickback",
    "cable-crunch": "Cable Crunch",
    "cable-woodchop": "Cable Woodchop",
    "cable-pull-through": "Cable Pull Through",
    "cable-overhead-ext": "Cable Overhead Extension",
    "cable-upright-row": "Cable Upright Row",
    "cable-reverse-fly": "Cable Reverse Fly",
    "cable-pullover": "Cable Pullover",
    "barbell-upright-row": "Barbell Upright Row",
    "landmine-press": "Landmine Press",
    "landmine-row": "Landmine Row",
    "barbell-hack-squat": "Barbell Hack Squat",
    "jefferson-squat": "Jefferson Squat",
    "barbell-hip-thrust": "Barbell Glute Bridge",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Pin Squat",
    "snatch-grip-deadlift": "Snatch Grip Deadlift",
    "trap-bar-deadlift": "Trap Bar Deadlift",
    "barbell-calf-raise": "Barbell Calf Raise",
    "barbell-pullover": "Barbell Pullover",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Single Leg Squat",
    "ring-dips": "Ring Dips",
    "ring-muscle-up": "Ring Muscle Up",
    "toes-to-bar": "Toes to Bar",
    "russian-twist": "Russian Twist",
    "pike-push-up": "Pike Push Up",
    "ab-wheel-rollout": "Ab Wheel Rollout",
    "plank": "Plank",
    "box-jump": "Box Jump",
    "glute-bridge": "Glute Bridge",
    "dumbbell-snatch": "DB Snatch",
    "dumbbell-clean": "DB Clean",
    "dumbbell-thruster": "DB Thruster",
    "dumbbell-floor-press": "DB Floor Press",
    "dumbbell-hip-thrust": "DB Hip Thrust",
    "renegade-row": "Renegade Row",
    "dumbbell-clean-press": "DB Clean & Press",
    "zottman-curl": "Zottman Curl",
    "spider-curl": "Spider Curl",
    "dumbbell-wrist-curl": "DB Wrist Curl",
    "leg-press-single": "Single Leg Press",
    "smith-shoulder-press": "Smith Shoulder Press",
    "smith-squat-split": "Smith Split Squat",
    "pendulum-squat": "Pendulum Squat",
    "seated-calf-raise": "Seated Calf Raise",
    "machine-lat-raise": "Machine Lateral Raise",
    "machine-bicep-curl": "Machine Bicep Curl",
    "machine-tricep-ext": "Machine Tricep Extension",
    "machine-rear-delt": "Machine Rear Delt Fly",
    "standing-calf-raise": "Standing Calf Raise Machine",
    "cable-hammer-curl": "Cable Hammer Curl",
    "cable-chest-press": "Cable Chest Press",
    "straight-arm-pulldown": "Straight Arm Pulldown",
    "cable-hip-abduction": "Cable Hip Abduction",
    "cable-shrug": "Cable Shrug",
    "bayesian-curl": "Bayesian Curl",
    "cable-front-raise": "Cable Front Raise",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Cable Crossover",
    "cable-tricep-kickback": "Cable Tricep Kickback",
    "cable-external-rotation": "Cable External Rotation",
    "cable-internal-rotation": "Cable Internal Rotation",
    "board-press": "Board Press",
    "box-squat": "Box Squat",
    "safety-bar-squat": "Safety Bar Squat",
    "block-pull": "Block Pull",
    "tempo-squat": "Tempo Squat",
    "sots-press": "Sots Press",
    "hang-clean": "Hang Clean",
    "hang-snatch": "Hang Snatch",
    "split-jerk": "Split Jerk",
    "clean-pull": "Clean Pull",
    "snatch-pull": "Snatch Pull",
    "barbell-drag-curl": "Barbell Drag Curl",
    "reverse-barbell-curl": "Reverse Barbell Curl",
    "barbell-spider-curl": "Barbell Spider Curl",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "DB Power Clean",
    "dumbbell-swing": "DB Swing",
    "dumbbell-split-squat": "DB Split Squat",
    "dumbbell-incline-fly": "DB Incline Fly",
    "dumbbell-decline-press": "DB Decline Press",
    "dumbbell-upright-row": "DB Upright Row",
    "single-arm-db-press": "Single Arm DB Press",
    "dumbbell-pullover-incline": "Incline DB Pullover",
    "dumbbell-kickback": "DB Tricep Kickback",
    "dumbbell-rear-lunge": "DB Reverse Lunge",
    "smith-incline-press": "Smith Incline Press",
    "smith-romanian-dl": "Smith Romanian Deadlift",
    "smith-calf-raise": "Smith Calf Raise",
    "machine-chest-fly": "Machine Chest Fly",
    "machine-pullover": "Machine Pullover",
    "machine-back-ext": "Machine Back Extension",
    "machine-ab-crunch": "Machine Ab Crunch",
    "machine-preacher-curl": "Machine Preacher Curl",
    "v-squat": "V Squat",
    "sissy-squat-machine": "Sissy Squat Machine",
    "wall-sit": "Wall Sit",
    "superman": "Superman",
    "bear-crawl": "Bear Crawl",
    "mountain-climber": "Mountain Climbers",
    "cossack-squat": "Cossack Squat",
    "decline-push-up": "Decline Push Up",
    "diamond-push-up": "Diamond Push Up",
    "archer-push-up": "Archer Push Up",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Human Flag",
    "wrist-curl": "Wrist Curl",
    "reverse-wrist-curl": "Reverse Wrist Curl",
    "farmers-walk": "Farmer's Walk",
    "plate-pinch": "Plate Pinch",
    "behind-back-wrist-curl": "Behind Back Wrist Curl",
    "dead-hang": "Dead Hang",
    "running-1-mile": "Takbo ng 1 Milya (1.6km)",
    "running-5k": "Takbo ng 5K",
    "running-10k": "Takbo ng 10K",
    "rowing-500m": "Sagwan 500m",
    "rowing-2000m": "Sagwan 2000m",
    "cycling-10k": "Pagbibisikleta 10K",
    "jump-rope-1min": "Luksong Lubid (1 min)",
    "swimming-100m": "Paglangoy 100m",
    "stair-climber-10min": "Pag-akyat ng Hagdan (10 min)",
    "battle-ropes-1min": "Battle Ropes (1 min)",
    "assault-bike-cal-1min": "Assault Bike (1 min cal)",
    "sled-push-40yd": "Sled Push (40 yd)"
  },
  id: {
    "bench-press": "Bench Press",
    "squat": "Squat",
    "deadlift": "Deadlift",
    "shoulder-press": "Shoulder Press",
    "barbell-curl": "Barbell Curl",
    "bent-over-row": "Bent Over Row",
    "incline-bench-press": "Incline Bench Press",
    "front-squat": "Front Squat",
    "romanian-deadlift": "Romanian Deadlift",
    "hip-thrust": "Hip Thrust",
    "power-clean": "Power Clean",
    "close-grip-bench": "Close Grip Bench Press",
    "lying-tricep-ext": "Lying Tricep Extension",
    "barbell-shrug": "Barbell Shrug",
    "ez-bar-curl": "EZ Bar Curl",
    "overhead-press": "Overhead Press",
    "sumo-deadlift": "Sumo Deadlift",
    "pendlay-row": "Pendlay Row",
    "barbell-lunge": "Barbell Lunge",
    "deficit-deadlift": "Deficit Deadlift",
    "floor-press": "Floor Press",
    "zercher-squat": "Zercher Squat",
    "snatch": "Snatch",
    "clean-and-jerk": "Clean and Jerk",
    "good-morning": "Good Morning",
    "rack-pull": "Rack Pull",
    "push-press": "Push Press",
    "decline-bench-press": "Decline Bench Press",
    "t-bar-row": "T-Bar Row",
    "pause-squat": "Pause Squat",
    "stiff-leg-deadlift": "Stiff Leg Deadlift",
    "behind-neck-press": "Behind Neck Press",
    "preacher-curl": "Preacher Curl",
    "skull-crusher": "Skull Crusher",
    "pull-ups": "Pull Up",
    "push-ups": "Push Up",
    "dips": "Dip",
    "chin-ups": "Chin Up",
    "muscle-ups": "Muscle Up",
    "sit-ups": "Sit Up",
    "pistol-squat": "Pistol Squat",
    "handstand-push-up": "Handstand Push Up",
    "planche": "Planche",
    "front-lever": "Front Lever",
    "hanging-leg-raise": "Hanging Leg Raise",
    "burpees": "Burpees",
    "inverted-row": "Inverted Row",
    "dragon-flag": "Dragon Flag",
    "l-sit": "L-Sit",
    "back-lever": "Back Lever",
    "nordic-curl": "Nordic Curl",
    "dumbbell-bench-press": "Dumbbell Bench Press",
    "dumbbell-curl": "Dumbbell Curl",
    "incline-db-bench": "Incline DB Bench Press",
    "dumbbell-shoulder-press": "DB Shoulder Press",
    "dumbbell-lateral-raise": "DB Lateral Raise",
    "dumbbell-row": "Dumbbell Row",
    "hammer-curl": "Hammer Curl",
    "goblet-squat": "Goblet Squat",
    "dumbbell-fly": "Dumbbell Fly",
    "dumbbell-pullover": "Dumbbell Pullover",
    "dumbbell-lunge": "Dumbbell Lunge",
    "dumbbell-shrug": "Dumbbell Shrug",
    "concentration-curl": "Concentration Curl",
    "dumbbell-tricep-ext": "DB Tricep Extension",
    "dumbbell-reverse-fly": "DB Reverse Fly",
    "arnold-press": "Arnold Press",
    "dumbbell-front-raise": "DB Front Raise",
    "dumbbell-romanian-dl": "DB Romanian Deadlift",
    "dumbbell-step-up": "DB Step Up",
    "dumbbell-skull-crusher": "DB Skull Crusher",
    "incline-dumbbell-curl": "Incline DB Curl",
    "dumbbell-calf-raise": "DB Calf Raise",
    "sled-leg-press": "Leg Press",
    "leg-extension": "Leg Extension",
    "chest-press": "Chest Press",
    "hack-squat": "Hack Squat",
    "seated-leg-curl": "Seated Leg Curl",
    "machine-calf-raise": "Machine Calf Raise",
    "smith-machine-squat": "Smith Machine Squat",
    "machine-shoulder-press": "Machine Shoulder Press",
    "pec-deck": "Pec Deck",
    "leg-press-horizontal": "Horizontal Leg Press",
    "lying-leg-curl": "Lying Leg Curl",
    "machine-row": "Machine Row",
    "hip-abduction": "Hip Abduction",
    "hip-adduction": "Hip Adduction",
    "assisted-pull-up": "Assisted Pull Up",
    "smith-bench-press": "Smith Bench Press",
    "reverse-hyper": "Reverse Hyper",
    "glute-ham-raise": "Glute Ham Raise",
    "belt-squat": "Belt Squat",
    "lat-pulldown": "Lat Pulldown",
    "tricep-pushdown": "Tricep Pushdown",
    "seated-cable-row": "Seated Cable Row",
    "cable-fly": "Cable Fly",
    "face-pull": "Face Pull",
    "cable-curl": "Cable Curl",
    "cable-lateral-raise": "Cable Lateral Raise",
    "cable-kickback": "Cable Kickback",
    "cable-crunch": "Cable Crunch",
    "cable-woodchop": "Cable Woodchop",
    "cable-pull-through": "Cable Pull Through",
    "cable-overhead-ext": "Cable Overhead Extension",
    "cable-upright-row": "Cable Upright Row",
    "cable-reverse-fly": "Cable Reverse Fly",
    "cable-pullover": "Cable Pullover",
    "barbell-upright-row": "Barbell Upright Row",
    "landmine-press": "Landmine Press",
    "landmine-row": "Landmine Row",
    "barbell-hack-squat": "Barbell Hack Squat",
    "jefferson-squat": "Jefferson Squat",
    "barbell-hip-thrust": "Barbell Glute Bridge",
    "z-press": "Z Press",
    "spoto-press": "Spoto Press",
    "pin-squat": "Pin Squat",
    "snatch-grip-deadlift": "Snatch Grip Deadlift",
    "trap-bar-deadlift": "Trap Bar Deadlift",
    "barbell-calf-raise": "Barbell Calf Raise",
    "barbell-pullover": "Barbell Pullover",
    "viking-press": "Viking Press",
    "larsen-press": "Larsen Press",
    "single-leg-squat": "Single Leg Squat",
    "ring-dips": "Ring Dips",
    "ring-muscle-up": "Ring Muscle Up",
    "toes-to-bar": "Toes to Bar",
    "russian-twist": "Russian Twist",
    "pike-push-up": "Pike Push Up",
    "ab-wheel-rollout": "Ab Wheel Rollout",
    "plank": "Plank",
    "box-jump": "Box Jump",
    "glute-bridge": "Glute Bridge",
    "dumbbell-snatch": "DB Snatch",
    "dumbbell-clean": "DB Clean",
    "dumbbell-thruster": "DB Thruster",
    "dumbbell-floor-press": "DB Floor Press",
    "dumbbell-hip-thrust": "DB Hip Thrust",
    "renegade-row": "Renegade Row",
    "dumbbell-clean-press": "DB Clean & Press",
    "zottman-curl": "Zottman Curl",
    "spider-curl": "Spider Curl",
    "dumbbell-wrist-curl": "DB Wrist Curl",
    "leg-press-single": "Single Leg Press",
    "smith-shoulder-press": "Smith Shoulder Press",
    "smith-squat-split": "Smith Split Squat",
    "pendulum-squat": "Pendulum Squat",
    "seated-calf-raise": "Seated Calf Raise",
    "machine-lat-raise": "Machine Lateral Raise",
    "machine-bicep-curl": "Machine Bicep Curl",
    "machine-tricep-ext": "Machine Tricep Extension",
    "machine-rear-delt": "Machine Rear Delt Fly",
    "standing-calf-raise": "Standing Calf Raise Machine",
    "cable-hammer-curl": "Cable Hammer Curl",
    "cable-chest-press": "Cable Chest Press",
    "straight-arm-pulldown": "Straight Arm Pulldown",
    "cable-hip-abduction": "Cable Hip Abduction",
    "cable-shrug": "Cable Shrug",
    "bayesian-curl": "Bayesian Curl",
    "cable-front-raise": "Cable Front Raise",
    "pallof-press": "Pallof Press",
    "cable-crossover": "Cable Crossover",
    "cable-tricep-kickback": "Cable Tricep Kickback",
    "cable-external-rotation": "Cable External Rotation",
    "cable-internal-rotation": "Cable Internal Rotation",
    "board-press": "Board Press",
    "box-squat": "Box Squat",
    "safety-bar-squat": "Safety Bar Squat",
    "block-pull": "Block Pull",
    "tempo-squat": "Tempo Squat",
    "sots-press": "Sots Press",
    "hang-clean": "Hang Clean",
    "hang-snatch": "Hang Snatch",
    "split-jerk": "Split Jerk",
    "clean-pull": "Clean Pull",
    "snatch-pull": "Snatch Pull",
    "barbell-drag-curl": "Barbell Drag Curl",
    "reverse-barbell-curl": "Reverse Barbell Curl",
    "barbell-spider-curl": "Barbell Spider Curl",
    "jm-press": "JM Press",
    "dumbbell-power-clean": "DB Power Clean",
    "dumbbell-swing": "DB Swing",
    "dumbbell-split-squat": "DB Split Squat",
    "dumbbell-incline-fly": "DB Incline Fly",
    "dumbbell-decline-press": "DB Decline Press",
    "dumbbell-upright-row": "DB Upright Row",
    "single-arm-db-press": "Single Arm DB Press",
    "dumbbell-pullover-incline": "Incline DB Pullover",
    "dumbbell-kickback": "DB Tricep Kickback",
    "dumbbell-rear-lunge": "DB Reverse Lunge",
    "smith-incline-press": "Smith Incline Press",
    "smith-romanian-dl": "Smith Romanian Deadlift",
    "smith-calf-raise": "Smith Calf Raise",
    "machine-chest-fly": "Machine Chest Fly",
    "machine-pullover": "Machine Pullover",
    "machine-back-ext": "Machine Back Extension",
    "machine-ab-crunch": "Machine Ab Crunch",
    "machine-preacher-curl": "Machine Preacher Curl",
    "v-squat": "V Squat",
    "sissy-squat-machine": "Sissy Squat Machine",
    "wall-sit": "Wall Sit",
    "superman": "Superman",
    "bear-crawl": "Bear Crawl",
    "mountain-climber": "Mountain Climbers",
    "cossack-squat": "Cossack Squat",
    "decline-push-up": "Decline Push Up",
    "diamond-push-up": "Diamond Push Up",
    "archer-push-up": "Archer Push Up",
    "skin-the-cat": "Skin the Cat",
    "human-flag": "Human Flag",
    "wrist-curl": "Wrist Curl",
    "reverse-wrist-curl": "Reverse Wrist Curl",
    "farmers-walk": "Farmer's Walk",
    "plate-pinch": "Plate Pinch",
    "behind-back-wrist-curl": "Behind Back Wrist Curl",
    "dead-hang": "Dead Hang",
    "running-1-mile": "Lari 1 Mil (1.6km)",
    "running-5k": "Lari 5K",
    "running-10k": "Lari 10K",
    "rowing-500m": "Dayung 500m",
    "rowing-2000m": "Dayung 2000m",
    "cycling-10k": "Bersepeda 10K",
    "jump-rope-1min": "Lompat Tali (1 menit)",
    "swimming-100m": "Renang 100m",
    "stair-climber-10min": "Naik Tangga (10 menit)",
    "battle-ropes-1min": "Battle Ropes (1 menit)",
    "assault-bike-cal-1min": "Assault Bike (1 menit kal)",
    "sled-push-40yd": "Dorong Kereta (40 yd)"
  }
};

export default exerciseNames;
